function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import __ from 'ramda/src/__';
import clone from 'ramda/src/clone';
import findIndex from 'ramda/src/findIndex';
import pathOr from 'ramda/src/pathOr';
import moment from 'moment';
import { retrieveOfferingsMetadata } from 'invision-core/src/components/metadata/offerings/offerings.actions';
import { hasAccess } from 'invision-core/src/components/security/permission.service';
import { loadCodeTables } from 'invision-core/src/components/metadata/codes/codes.helpers';
import i18n from 'invision-core/src/components/i18n/i18n';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { CUSTOMER_URL } from '../../../../customer/customer.config';
import { DASHBOARD_ROUTE } from '../../../../../reducers/constants/dashboard.constants';
import { ShowCustomerAutoPayBannerSelector } from '../../../../../reducers/selectors/customer.account.status.selectors';
import { LastRouteSelector, PageSizePreferenceSelector, UserSecurityAttributesSelector } from 'invision-core/src/components/session/session.selectors';
import { RouteParams } from 'invision-core/src/components/router/router.selectors';
import { registerUnsavedChanges, unregisterUnsavedChanges } from 'invision-core/src/components/unsavedChangesPrompt/actions';
import { MetadataCodeLoadedSelector, MetadataCodeTypeIntegerSelector, MetadataCodeTypeSelector, SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault, SubscriberRequirementsForCurrentBusinessUnitOrDefault } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { getShippingMethodsByCountryCode } from 'invision-core/src/components/metadata/shippingMethods/shipping.methods.actions';
import { AllAttributesAreValidSelector, AttributeServiceSelector, BackButtonTextSelector, CurrentActiveAttributeNameSelector, CustomerInfoSelector, FilteredFormAttributeGroups, FilteredPhysicalAttributeGroups, FormattedNameSelector, FormAttributeGroups, FormPhysicalAttributeGroups, ForwardButtonTextSelector, GroupedCheckboxFilterOptionsSelector, HasRequiredAndUnavailableInventorySelector, IsContinueDisabledSelector, IsContinueShoppingShownSelector, IsFetchingAnyDataSelector, IsSaveButtonShownSelector, IsSendToStoreButtonEnabledSelector, OfferOptionViewModelSelector, ShowNextButtonSelector, ShowPreviousButtonSelector, StepProgressBarViewModelSelector, SummaryTabViewModel, UnavailablePhysicalInventorySelector } from './add.offer.wizard.selectors';
import { beginAddOfferOrder, calculateAddOfferOrderQuoteWithTaxes, cancelOrder, clearQuoteAndSetSelectedOffer, fetchAddOfferAttributesAndNavigate, fetchAddOfferDecisionsAndNavigate, fetchAddresses, fetchAttributes, fetchWallet, goToNextStep, goToPreviousStep, goToStep, initializeAsMultiOfferWizard, multiOfferSetCompletedSteps, resetForContinueShopping, resetOfferAdditionalProperties, resetMultiOffers, resetPickupId, restoreOptionDefaultPricing, resumeOrder, resumeOrderAttributes, resumeStoreOrder, retrieveShoppingCartOfferings, saveBulkPricing, searchAttributeInventory, sendPortInOrItemReservation, setChangeOfferingId, setChangeOfferingInstanceId, setCurrentStepIsInvalid, setDecisionsTouched, setDownPaymentOnMultiOfferShoppingCart, setEditAttributeGroups, setEditCartAdditionalProperty, setEditCartAdditionalPropertyOnChange, setEditOption, setEditOrderAdditionalProperty, setEditOrderAdditionalPropertyOnChange, setEditOfferAdditionalProperty, setEditOfferAdditionalPropertyOnChange, setEditPhysicalAttributeGroups, setIsResumingOrder, setIsResumingStoreOrder, setMultiOfferShoppingCart, setPaymentInfo, setRemoveOfferInstanceId, setSelectedFacetsEditCopy, setSelectedOfferEditCopy, setSelectedOfferingChargeTypesEditCopy, setSelectedOfferingInstanceId, setSelectedTab, setTransferFromName, setTransferFromSubscriberId, submitAddOrder, updateAttribute, updateBillCycle, updateCart, updateEditOptionPrice, updateInventorySelection, updateOfferPhysicalInventoryMakeAndModel, updateOfferPhysicalInventoryTypeAttribute, updatePaymentInfo, updatePortInRequest, updateSelectedServiceFeatures, updateShoppingCart } from '../../../../../reducers/actions/add.offer.wizard.actions';
import { calculateOfferingOrderQuote, clearOfferingOrderQuote, clearQuote, replaceMultiOfferShoppingCart, resetAvailableInventoryInformation, resetInventoryStorePickupDetails, retrieveOffCycleNextRenewalSchedules, retrieveOfferingOrderQuote, retrieveOrderQuote, saveInventoryStorePickupDetails, searchAvailableOfferings, searchInventoriesAvailability, sendInventoryToStore, setActiveAttributeFormName, setAttributeFormSubmitted, setCheckoutDetailsValidation, setDecisionsSelectedPageId, setDeliveryDecision, setDevicePaymentOptions, setInventoryRegionFilter, setInventoryStoreChangedFlag, setSelectedInventoryStores, updateMultiOfferShoppingCart, updateShippingDetails, updateServiceTaxLocationDecision } from '../../../../../reducers/actions/offering.order.actions';
import { retrieveAvailablePaymentInstrumentTypes, retrieveWalletAndSelectDefaultPaymentMethod } from '../../../../../reducers/actions/customer.ewallet.actions';
import { AddedOffersSelector, AddOfferAsyncIdSelector, AddOfferDeliveryMethodOptionsSelector, AddOfferShoppingCartPhysicalInventoriesSelector, AddOfferStoreAvailabilitySelector, AddOfferSubscriberInventoryAvailabilityInventorySelector, AllPhysicalInventoryItemsFromAddOfferSelector, AvailableCreditFromQuoteBreachedSelector, AvailableFinanceCreditFromQuoteSelector, BillCycleSelector, BillingAddressStateRegionProvinceValueOptionsSelector, CartAdditionalPropertiesSelector, CartAdditionalPropertyListMapSelector, ChangeOfferingInstanceIdSelector, CompletedStepsSelector, CurrentStepIndexSelector, CurrentStepIsInvalidSelector, CurrentStepSelector, DeliveryOptionsByPricingPlanSelector, EditedMultiOfferShoppingCartSelector, EditOptionSelector, EditOptionsSelector, EditSelectedFacetIdsSelector, EditSelectedOfferingChargeTypeIdSelector, FormattedAttributesSelector, FormattedCityStateSelector, FormattedDeliveryDecisionsSelector, FormattedPhysicalAttributesSelector, HasOffCycleChargeRenewalAddOfferSelector, InitializeAsMultiOfferWizardSelector, InventoryAvailabilityRequestsSelector, IsAddOfferPaymentInstrumentRequiredSelector, IsAsyncCompleteSelector, IsAttributesStepSelector, IsCheckoutStepSelector, IsCreditLimitBreachedFromQuoteSelector, IsDecisionsStepSelector, IsDecisionsTouchedSelector, IsFullCartAsyncCompleteSelector, IsMultiOfferEditingSelector, IsMultiOfferSelector, IsMultiOfferShoppingCartPrepaidSelector, IsOffersStepSelector, IsRemovingOfferSavedToMultiOfferCartSelector, IsResumingOrderSelector, IsResumingStoreOrderSelector, IsRetrievingMultiOfferCartSelector, IsSavingOrderSelector, IsShippingRequiredSelector, IsTransferWizardSelector, MultiOfferCartContainsOfferWithAtleastOneBillerRuleCycleLevelAsItemSelector, MultiOfferFinancedItemsForDownpaymentSelector, MultiOfferIdsSelector, MultiOfferShoppingCartSelector, OfferAdditionalPropertiesSelector, OfferAdditionalPropertyListMapSelector, OffersCountSelector, OrderAdditionalPropertiesSelector, OrderAdditionalPropertyListMapSelector, PaymentInfoEditSelector, PaymentInfoSelector, PickupIdSelector, QuoteCalculatedSelector, QuoteHasInvoiceItemsSelector, RemoveOfferInstanceIdSelector, SelectedOfferIdSelector, SelectedOfferIndexSelector, SelectedOfferingInstanceIdSelector, SelectedTabIndexSelector, ServiceAddressSelector, ServiceTaxDecisionsSelector, ShippingAddressDropdownOptionsSelector, ShippingAddressSelector, ShoppingCartWithoutRemovedOfferSelector, SubscriberPhysicalInventoryPickupDetailSelector, SubscriptionDataForPreview, TabPanelViewModelSelector, TaxLocationDecisionsByPricingPlanSelector, TransferFromNameSelector, TransferFromSubscriberIdSelector, ValidPaymentInstrument } from '../../../../../reducers/selectors/add.offer.wizard.selectors';
import { CurrentCustomerBillCycleSelector, CurrentCustomerCreditLimitSelector, CurrentCustomerIdSelector, CurrentCustomerIsExternallyManagedARSelector, CurrentCustomerNameSelector, CurrentCustomerSelector, IsCreatingCustomerSelector, IsExistingCartSelector, IsTransferCartFromCurrentCustomerSelector, SelectedCustomerHomeCountrySelector, ShoppingCartErrorSelector } from '../../../../../reducers/selectors/customer.selectors';
import { AreAnyInventoryUnavailableSelector, AttributeFormSubmittedSelector, CartContainsOffcycleOfferSelector, CompletedDecisionsSelector, CurrentRemoveOfferSelector, DecisionsHasErrorSelector, FilteredStoresOnSelectedRegionForStoresSearchModalSelector, InventoryAvailabilitySelector, IsAllSelectedPhysicalInventoryPresentAtSelectedStore, IsSaveOrderButtonDisabledSelector, IsSelectedOfferingChangeable, IsUpdatingCartSelector, PaymentInstrumentRequiredSelector, SaveOrderButtonTooltipTextSelector, SelectedOfferingServiceIdentifiersSelector, ShoppingCartHaveOnlyStandaloneItemsSelector, ShoppingCartSelector, SubmittedOrderErrorSelector, SelectedDeliveryDecisionFromRocSelector } from '../../../../../reducers/selectors/selected.offering.order.selectors';
import { duplicatedServiceIdentifierAttributes, getShoppingCartWithUpdatedStoreIdForAPIRequest, getMultiOfferShoppingCartWithUpdatedDeliveryDecision } from '../../../../../reducers/helpers/offer.ordering.wizard.helper';
import { STATE_OR_NAME } from '../../../../../reducers/constants/add.offer.wizard.constants';
import { ContextOfferingAction, OFFERINGS_SEARCH_CONSTANTS } from '../../../../../reducers/constants/wizard.constants';
import CustomerCareKeys from '../../../../../locales/keys';
import { EwalletErrorSelector, SelectedPaymentAutoPayEnable, SelectedPaymentForSubmitAtCheckoutSelector, SelectedPaymentMethodSelector, RecordPaymentInformationSelector, SupplyPaymentInstrumentSelector } from '../../../../../reducers/selectors/customer.ewallet.selectors';
import { DELIVERY_OPTIONS, DUPLICATE_SERVICE_IDENTIFIER_FAULT_CODE, EXISTING_SAVED_CART_FOR_SEND_TO_STORE_FAULT_CODE, INVENTORY_ITEM_RESERVATION_FAULT_CODE, ORDER_SCENARIOS, RESUME_ORDER_INSUFFICIENT_ACCESS_WARNING_CODE, RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION } from '../../../../../customercare.constants';
import FaultCodeKeys from '../../../../../../src/api/fault.code.keys';
import { AsyncStatusSelector, CreatedOrderCurrencyCodeSelector, CreatedOrderSelector, DbssShippingEnabledRegionIdSelector, FullCartAsyncStatusSelector, InventoryStorePickupDetailsSelector, InventoryStoresTableDataSelector, IsQuoteBypassedSelector, IsQuotingOfferSelector, IsInventoryStoreChangedSelector, IsInventoryStoreConfiguredSelector, IsSendingInventoryToStoreSelector, IsSubmittingOrderSelector, OffcycleRenewalScheduleSelector, OfferingOrderCheckoutPageEditFormSelector, OfferingOrderQuoteSelector, SelectedDeliveryDecisionSelector, SelectedInventoryRegionSelector, InventoryRegionWithoutWarehouseSelector, SelectedOrderDetailsSelector, SelectedInventoryStoresDetailsSelector, SelectedOrderExecutionOptionsSelector, SelectedShippingAddressAndMethodSelector, ViewLastAttemptErrorSelector } from '../../../../../reducers/selectors/offering.order.selectors';
import { SelectedContractSelector } from '../../../../../reducers/selectors/contract.selectors';
import { cancelStoreOrder, setCustomerCategory, setEditAdditionalProperty } from '../../../../../reducers/actions/customer.actions';
import { searchContracts } from '../../../../../reducers/actions/contracts.list.actions';
import { ContractsSearchResultsSelector } from '../../../../../reducers/selectors/contracts.list.selectors';
import { resetMobileNumberPortabilityModels } from '../../../../../reducers/actions/mobile.number.portability.actions';
import { setCustomerAutoPayBannerFlag } from '../../../../../reducers/actions/customer.account.status.actions';
import { setSelectedContract } from '../../../../../reducers/actions/contract.details.actions';
import { setForceShowEditFormAddress, validateAddress } from '../../../../../reducers/actions/address.component.actions';
import { ValidatedAddressesSelector, UnvalidatedAddressesSelector } from '../../../../../reducers/selectors/address.component.selectors';
import { isAddressValidFromAddressResponse } from '../../../../shared/contextualComponents/address/address.validator.helper';
import { OfferWizard } from '../../offer.wizard.common';
import { SUBSCRIBER_TYPE_EDIT_ACCESS } from '../../../../../security.attributes';
import { FullCartOfferingOrderQuotesSelector, FullCartOfferingOrderQuoteTotalSelector, FullCartOfferingOrderFeeQuoteSelector, FullCartOfferingOrderTaxQuoteSelector, FullCartOfferingOrderShippingQuoteSelector, ShowHideFullCartColumnsSelector } from '../../../../../reducers/selectors/full.cart.selectors';
import { asyncRepeatInterval } from '../../../../../reducers/helpers/async.helper';
import { FormattedEditCustomerSubscriberIdentitiesSelector } from '../../../../../reducers/selectors/customer.information.selectors';
import { CurrentCustomerNodeSelector } from '../../../../../reducers/selectors/customer.account.hierarchy.selectors';
import { REPORTING_LEVELS } from '../../../accountHierarchy/account.hierarchy.constants';
import { CUSTOMER_CATEGORY } from '../../../../createCustomerPopup/create.customer.popup.constants';
var AddOfferWizardController = /*#__PURE__*/function (_OfferWizard) {
  function AddOfferWizardController($q, $scope, $ngRedux, $filter, $interval, $log, $state, $location, $anchorScroll, $timeout, $element, uiNotificationService, unsavedChangesPrompt) {
    var _this;
    _classCallCheck(this, AddOfferWizardController);
    _this = _callSuper(this, AddOfferWizardController);
    Object.assign(_this, {
      $q: $q,
      $anchorScroll: $anchorScroll,
      $element: $element,
      $filter: $filter,
      $interval: $interval,
      $location: $location,
      $log: $log,
      $ngRedux: $ngRedux,
      $scope: $scope,
      $state: $state,
      $timeout: $timeout,
      autoPayBannerFlag: false,
      contextOfferingAction: ContextOfferingAction.ADD,
      customerCareKeys: CustomerCareKeys,
      customerCategory: CUSTOMER_CATEGORY,
      DELIVERY_OPTIONS: DELIVERY_OPTIONS,
      fullCartEditOfferingInstanceId: null,
      isCartExisting: false,
      isContinueShopping: false,
      isInventoryItemReservationFault: false,
      isLoading: false,
      isRemovingOffer: false,
      isResumingCancelOrderButton: false,
      orderScenario: ORDER_SCENARIOS.ADD_OFFER,
      overrideBypassQuoteConfiguration: false,
      resumeOrderWarning: RESUME_ORDER_INSUFFICIENT_ACCESS_WARNING_CODE,
      REPORTING_LEVELS: REPORTING_LEVELS,
      retrieveOfferingOrderQuoteTimestamp: null,
      retrieveOrderQuoteTimestamp: null,
      saveOrderErrorMessage: '',
      showPreviewRenewalStatementsDialog: true,
      showSendToStorePopup: false,
      showViewFullCartPopup: false,
      stateOrName: STATE_OR_NAME,
      uiNotificationService: uiNotificationService,
      unsavedChangesPrompt: unsavedChangesPrompt,
      attemptNextStep: _this.attemptNextStep.bind(_this),
      cancelAddingOrEditingOffer: _this.cancelAddingOrEditingOffer.bind(_this),
      changeOfferClick: _this.changeOfferClick.bind(_this),
      closeRemoveOfferConfirmation: _this.closeRemoveOfferConfirmation.bind(_this),
      closeResumeOrderErrorPopup: _this.closeResumeOrderErrorPopup.bind(_this),
      closeSearchInventoryPopupDialog: _this.closeSearchInventoryPopupDialog.bind(_this),
      closeSelectStorePopupDialog: _this.closeSelectStorePopupDialog.bind(_this),
      closeSendToStorePopup: _this.closeSendToStorePopup.bind(_this),
      closeViewFullCartPopupDialog: _this.closeViewFullCartPopupDialog.bind(_this),
      editOfferClick: _this.editOfferClick.bind(_this),
      fetchOrderQuote: _this.fetchOrderQuote.bind(_this),
      finishAttributes: _this.finishAttributes.bind(_this),
      handleClosePreviewRenewalStatementsDialog: _this.handleClosePreviewRenewalStatementsDialog.bind(_this),
      handleCloseSaveOrderErrorPopup: _this.handleCloseSaveOrderErrorPopup.bind(_this),
      handleCloseSubmitOrderErrorPopup: _this.handleCloseSubmitOrderErrorPopup.bind(_this),
      handleCloseSubmitTransferOrderPopup: _this.handleCloseSubmitTransferOrderPopup.bind(_this),
      handlePreviewRenewalStatements: _this.handlePreviewRenewalStatements.bind(_this),
      handleRemoveOffer: _this.handleRemoveOffer.bind(_this),
      handleResultExistingCartPromptPopup: _this.handleResultExistingCartPromptPopup.bind(_this),
      handleResultSaveOrderPromptPopup: _this.handleResultSaveOrderPromptPopup.bind(_this),
      handleResultTransferOrderPopup: _this.handleResultTransferOrderPopup.bind(_this),
      handleResultUnsavedChangesPromptPopup: _this.handleResultUnsavedChangesPromptPopup.bind(_this),
      handleSingleOfferChange: _this.handleSingleOfferChange.bind(_this),
      handleSubmitForPickupCancel: _this.handleSubmitForPickupCancel.bind(_this),
      handleSubmitForPickupErrorPopup: _this.handleSubmitForPickupErrorPopup.bind(_this),
      onCartAdditionalPropertyChanged: _this.onCartAdditionalPropertyChanged.bind(_this),
      onCartAdditionalPropertyListUpdated: _this.onCartAdditionalPropertyListUpdated.bind(_this),
      onInventoryRegionFilterChanged: _this.onInventoryRegionFilterChanged.bind(_this),
      onInventoryRegionFilterChangedForStoreSearch: _this.onInventoryRegionFilterChangedForStoreSearch.bind(_this),
      onItemDownpaymentChanged: _this.onItemDownpaymentChanged.bind(_this),
      onAdditionalPropertyChanged: _this.onAdditionalPropertyChanged.bind(_this),
      onAdditionalPropertyListUpdated: _this.onAdditionalPropertyListUpdated.bind(_this),
      onOverrideCalculateQuote: _this.onOverrideCalculateQuote.bind(_this),
      onRefreshOfferingQuote: _this.onRefreshOfferingQuote.bind(_this),
      onRefreshQuote: _this.onRefreshQuote.bind(_this),
      onSelectInventoryStore: _this.onSelectInventoryStore.bind(_this),
      onStepSubmit: _this.onStepSubmit.bind(_this),
      openStoreSearch: _this.openStoreSearch.bind(_this),
      repeatRetrieveOfferingQuote: _this.repeatRetrieveOfferingQuote.bind(_this),
      recalculateOrderQuote: _this.recalculateOrderQuote.bind(_this),
      recallOfferingContext: _this.recallOfferingContext.bind(_this),
      repeatRetrieveQuote: _this.repeatRetrieveQuote.bind(_this),
      removeOffer: _this.removeOffer.bind(_this),
      sendToStore: _this.sendToStore.bind(_this),
      setSelectedStoreForSearchModal: _this.setSelectedStoreForSearchModal.bind(_this),
      updateCart: _this.updateCart.bind(_this)
    });
    Promise.all(loadCodeTables(_this.$ngRedux.getState(), _this.$ngRedux.dispatch, [CODES.FinanceBillerRuleConfiguration, CODES.InventoryRegion, CODES.OneTimeBillerRuleConfiguration, CODES.PeriodType, CODES.ReasonCodes, CODES.RecurringBillerRuleConfiguration, CODES.Stores, CODES.SubscriptionBillingCycle])).catch(function (error) {
      _this.uiNotificationService.transientError(error.translatedMessage);
    });
    return _this;
  }
  _inherits(AddOfferWizardController, _OfferWizard);
  return _createClass(AddOfferWizardController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          addedOffers: AddedOffersSelector(store),
          additionalPropValueOptions: MetadataCodeTypeIntegerSelector(CODES.AdditionalPropertyValue, store),
          addOfferShoppingCartPhysicalInventoryItems: AddOfferShoppingCartPhysicalInventoriesSelector(store),
          addressStates: BillingAddressStateRegionProvinceValueOptionsSelector(store),
          allAttributesAreValid: AllAttributesAreValidSelector(store),
          areAnyInventoryUnavailable: AreAnyInventoryUnavailableSelector(store),
          asyncId: AddOfferAsyncIdSelector(store),
          asyncStatus: AsyncStatusSelector(store),
          attributeFormSubmitted: AttributeFormSubmittedSelector(store),
          availableCreditFromQuote: AvailableCreditFromQuoteBreachedSelector(store),
          availableFinanceCreditFromQuote: AvailableFinanceCreditFromQuoteSelector(store),
          availableInventoryInformation: InventoryAvailabilitySelector(store),
          backButtonText: BackButtonTextSelector(store),
          billCycle: BillCycleSelector(store),
          cartAdditionalProperties: CartAdditionalPropertiesSelector(store),
          cartAdditionalPropertyListMap: CartAdditionalPropertyListMapSelector(store),
          cartContainsOffcycleOffer: CartContainsOffcycleOfferSelector(store),
          changeOfferingInstanceId: ChangeOfferingInstanceIdSelector(store),
          codeTypeLoaded: MetadataCodeLoadedSelector(__, store),
          completedDecisions: CompletedDecisionsSelector(store),
          completedSteps: CompletedStepsSelector(store),
          contracts: ContractsSearchResultsSelector(store),
          createdOrder: CreatedOrderSelector(store),
          createOrderError: ViewLastAttemptErrorSelector(store),
          currencyCode: CreatedOrderCurrencyCodeSelector(store),
          currentAttributeTitle: CurrentActiveAttributeNameSelector(store),
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerBillCycle: CurrentCustomerBillCycleSelector(store),
          currentCustomerCreditLimit: CurrentCustomerCreditLimitSelector(store),
          currentCustomerIsExternallyManagedAR: CurrentCustomerIsExternallyManagedARSelector(store),
          currentCustomerName: CurrentCustomerNameSelector(store),
          currentCustomerNode: CurrentCustomerNodeSelector(store),
          currentRemoveOffer: CurrentRemoveOfferSelector(store),
          currentStep: CurrentStepSelector(store),
          currentStepIndex: CurrentStepIndexSelector(store),
          currentStepIsInvalid: CurrentStepIsInvalidSelector(store),
          customerId: CurrentCustomerIdSelector(store),
          customerInfo: CustomerInfoSelector(store),
          dbssShippingEnabledRegionId: DbssShippingEnabledRegionIdSelector(store),
          deliveryMethodOptions: AddOfferDeliveryMethodOptionsSelector(store),
          deliveryOptionsByPricingPlan: DeliveryOptionsByPricingPlanSelector(store),
          editOption: EditOptionSelector(store),
          editOptions: EditOptionsSelector(store),
          editedMultiOfferShoppingCart: EditedMultiOfferShoppingCartSelector(store),
          editModalSideNavList: OfferingOrderCheckoutPageEditFormSelector(store),
          formattedEditCustomerSubscriberIdentities: FormattedEditCustomerSubscriberIdentitiesSelector(store),
          executionOptions: SelectedOrderExecutionOptionsSelector(store),
          filteredFormAttributeGroups: FilteredFormAttributeGroups(store),
          filteredPhysicalAttributeGroups: FilteredPhysicalAttributeGroups(store),
          filteredStoresOnSelectedRegionForStoresSearchModal: FilteredStoresOnSelectedRegionForStoresSearchModalSelector(store),
          formattedAttributes: FormattedAttributesSelector(store),
          formattedCityState: FormattedCityStateSelector(store),
          formattedDeliveryDecisions: FormattedDeliveryDecisionsSelector(store),
          formattedName: FormattedNameSelector(store),
          formattedPhysicalAttributes: FormattedPhysicalAttributesSelector(store),
          formattedPhysicalInventories: AddOfferSubscriberInventoryAvailabilityInventorySelector(store),
          formAttributeGroups: FormAttributeGroups(store),
          formPhysicalAttributeGroups: FormPhysicalAttributeGroups(store),
          forwardButtonText: ForwardButtonTextSelector(store),
          fullCartAsyncStatus: FullCartAsyncStatusSelector(store),
          fullCartOfferingOrderQuotes: FullCartOfferingOrderQuotesSelector(store),
          fullCartOfferingOrderQuoteTotal: FullCartOfferingOrderQuoteTotalSelector(store),
          fullCartOfferingOrderShippingQuote: FullCartOfferingOrderShippingQuoteSelector(store),
          fullCartOfferingOrderFeeQuote: FullCartOfferingOrderFeeQuoteSelector(store),
          fullCartOfferingOrderTaxQuote: FullCartOfferingOrderTaxQuoteSelector(store),
          groupedCheckboxFilterOptions: GroupedCheckboxFilterOptionsSelector(store),
          hasDecisionValidationError: DecisionsHasErrorSelector(store),
          hasInvoiceItems: QuoteHasInvoiceItemsSelector(store),
          hasOffCycleChargeRenewal: HasOffCycleChargeRenewalAddOfferSelector(store),
          hasRequiredAndUnavailableInventory: HasRequiredAndUnavailableInventorySelector(store),
          initializeAsMultiOfferWizard: InitializeAsMultiOfferWizardSelector(store),
          inventoryAvailabilityRequests: InventoryAvailabilityRequestsSelector(store),
          inventoryRegions: InventoryRegionWithoutWarehouseSelector(store),
          inventoryStorePickupDetails: InventoryStorePickupDetailsSelector(store),
          isAllSelectedPhysicalInventoryAvailable: IsAllSelectedPhysicalInventoryPresentAtSelectedStore(store),
          isAttributesStep: IsAttributesStepSelector(store),
          isCalculatingQuote: IsQuotingOfferSelector(store),
          isCheckoutStep: IsCheckoutStepSelector(store),
          isContinueDisabled: IsContinueDisabledSelector(store),
          isContinueShoppingShown: IsContinueShoppingShownSelector(store),
          isConvergentBiller: IsDbss(store),
          isCreatingCustomer: IsCreatingCustomerSelector(store),
          isCreditLimitBreached: IsCreditLimitBreachedFromQuoteSelector(store),
          isDbss: IsDbss(store),
          isDecisionsStep: IsDecisionsStepSelector(store),
          isDecisionsTouched: IsDecisionsTouchedSelector(store),
          isExistingCart: IsExistingCartSelector(store),
          isFetchingAnyData: IsFetchingAnyDataSelector(store),
          isFullCartAsyncComplete: IsFullCartAsyncCompleteSelector(store),
          isInventoryStoreChanged: IsInventoryStoreChangedSelector(store),
          isInventoryStoreConfigured: IsInventoryStoreConfiguredSelector(store),
          isMultiOffer: IsMultiOfferSelector(store),
          isMultiOfferCartPrepaid: IsMultiOfferShoppingCartPrepaidSelector(store),
          isMultiOfferEditing: IsMultiOfferEditingSelector(store),
          isOffersStep: IsOffersStepSelector(store),
          isPaymentInstrumentRequired: IsAddOfferPaymentInstrumentRequiredSelector(store),
          isQuoteBypassed: IsQuoteBypassedSelector(store),
          isQuoteCalculated: QuoteCalculatedSelector(store),
          isAsyncComplete: IsAsyncCompleteSelector(store),
          isRemovingOfferSavedToMultiOfferCart: IsRemovingOfferSavedToMultiOfferCartSelector(store),
          isResumingOrder: IsResumingOrderSelector(store),
          isResumingStoreOrder: IsResumingStoreOrderSelector(store),
          isRetrievingMultiOfferCart: IsRetrievingMultiOfferCartSelector(store),
          isSaveButtonShown: IsSaveButtonShownSelector(store),
          isSaveOrderButtonDisabled: IsSaveOrderButtonDisabledSelector(store),
          isSavingOrder: IsSavingOrderSelector(store),
          isSelectedOfferingChangeable: IsSelectedOfferingChangeable(store),
          isSendingInventoryToStore: IsSendingInventoryToStoreSelector(store),
          isSendToStoreButtonEnabled: IsSendToStoreButtonEnabledSelector(store),
          isShippingRequired: IsShippingRequiredSelector(store),
          isSubmittingOrder: IsSubmittingOrderSelector(store),
          isTransferCart: IsTransferCartFromCurrentCustomerSelector(store),
          isTransferWizard: IsTransferWizardSelector(store),
          isUpdatingCart: IsUpdatingCartSelector(store),
          lastAttemptError: SubmittedOrderErrorSelector(store),
          lastRoute: LastRouteSelector(store),
          multiOfferCartContainsOfferWithAtleastOneBillerRuleCycleLevelAsItem: MultiOfferCartContainsOfferWithAtleastOneBillerRuleCycleLevelAsItemSelector(store),
          multiOfferFinancedItems: MultiOfferFinancedItemsForDownpaymentSelector(store),
          multiOfferShoppingCart: MultiOfferShoppingCartSelector(store),
          offcycleRenewalSchedule: OffcycleRenewalScheduleSelector(store),
          offerIds: MultiOfferIdsSelector(store),
          offeringOrderQuote: OfferingOrderQuoteSelector(store),
          offerAdditionalProperties: OfferAdditionalPropertiesSelector(store),
          offerAdditionalPropertyListMap: OfferAdditionalPropertyListMapSelector(store),
          offerOptionViewModel: OfferOptionViewModelSelector(store),
          offersCount: OffersCountSelector(store),
          orderAdditionalProperties: OrderAdditionalPropertiesSelector(store),
          orderAdditionalPropertyListMap: OrderAdditionalPropertyListMapSelector(store),
          orderDetails: SelectedOrderDetailsSelector(store),
          pageSize: PageSizePreferenceSelector(store),
          paymentInfo: PaymentInfoSelector(store),
          paymentInfoEdit: PaymentInfoEditSelector(store),
          paymentInstrumentRequired: PaymentInstrumentRequiredSelector(store),
          periodTypes: MetadataCodeTypeSelector(CODES.PeriodType, store),
          physicalInventories: AllPhysicalInventoryItemsFromAddOfferSelector(store),
          pickupId: PickupIdSelector(store),
          recordPaymentInfo: RecordPaymentInformationSelector(store),
          removeOfferInstanceId: RemoveOfferInstanceIdSelector(store),
          retrieveEwalletError: EwalletErrorSelector(store),
          routeParams: RouteParams(store),
          saveOrderButtonTooltipText: SaveOrderButtonTooltipTextSelector(store),
          selectedContract: SelectedContractSelector(store),
          selectedCustomerHomeCountry: SelectedCustomerHomeCountrySelector(store),
          selectedDeliveryDecision: SelectedDeliveryDecisionSelector(store),
          selectedDeliveryDecisionFromRoc: SelectedDeliveryDecisionFromRocSelector(store),
          selectedInventoryRegion: SelectedInventoryRegionSelector(store),
          selectedInventoryStores: SelectedInventoryStoresDetailsSelector(store),
          selectedInventoryStoresItemAvailability: AddOfferStoreAvailabilitySelector(store),
          selectedOfferId: SelectedOfferIdSelector(store),
          selectedOfferIndexSelector: SelectedOfferIndexSelector(store),
          selectedOfferingInstanceId: SelectedOfferingInstanceIdSelector(store),
          // Applicable for Multi-Offer flow.
          selectedOfferingServiceIdentifiers: SelectedOfferingServiceIdentifiersSelector(store),
          selectedPayment: SelectedPaymentMethodSelector(store),
          selectedPaymentClean: SelectedPaymentForSubmitAtCheckoutSelector(store),
          selectedPaymentMethodAutoPay: SelectedPaymentAutoPayEnable(store),
          selectedShippingAddressAndMethod: SelectedShippingAddressAndMethodSelector(store),
          selectedTabIndex: SelectedTabIndexSelector(store),
          serviceAddress: ServiceAddressSelector(store),
          services: AttributeServiceSelector(store),
          serviceTaxDecisions: ServiceTaxDecisionsSelector(store),
          shippingAddress: ShippingAddressSelector(store),
          shippingAddressDropdownOptions: ShippingAddressDropdownOptionsSelector(store),
          shoppingCart: ShoppingCartSelector(store),
          shoppingCartError: ShoppingCartErrorSelector(store),
          shoppingCartHaveOnlyStandaloneItems: ShoppingCartHaveOnlyStandaloneItemsSelector(store),
          shoppingCartIsPrepaid: IsMultiOfferShoppingCartPrepaidSelector(store),
          shoppingCartWithoutRemovedOffer: ShoppingCartWithoutRemovedOfferSelector(store),
          shouldShowNextButton: ShowNextButtonSelector(store),
          shouldShowPreviousButton: ShowPreviousButtonSelector(store),
          showCustomerAutoPayBanner: ShowCustomerAutoPayBannerSelector(store),
          showHideFullCartColumns: ShowHideFullCartColumnsSelector(store),
          stepsProgressBarViewModel: StepProgressBarViewModelSelector(store),
          storesTableData: InventoryStoresTableDataSelector(store),
          subscriberPhysicalInventoryPickupDetail: SubscriberPhysicalInventoryPickupDetailSelector(store),
          subscriptionBillingCycles: MetadataCodeTypeSelector(CODES.SubscriptionBillingCycle, store),
          subscriptionDataForPreview: SubscriptionDataForPreview(store),
          subscriberCategoryRequirements: SubscriberCategoryRequirementsForCurrentBusinessUnitOrDefault(store),
          subscriberRequirements: SubscriberRequirementsForCurrentBusinessUnitOrDefault(store),
          summaryTabViewModel: SummaryTabViewModel(store),
          supplyPaymentInstrument: SupplyPaymentInstrumentSelector(store),
          tabs: TabPanelViewModelSelector(store),
          transferFromName: TransferFromNameSelector(store),
          taxLocationDecisionsByPricingPlan: TaxLocationDecisionsByPricingPlanSelector(store),
          transferFromSubscriberId: TransferFromSubscriberIdSelector(store),
          unavailablePhysicalInventory: UnavailablePhysicalInventorySelector(store),
          unvalidatedAddresses: UnvalidatedAddressesSelector(store),
          userSecurityAttributes: UserSecurityAttributesSelector(store),
          validatedAddresses: ValidatedAddressesSelector(store),
          validPaymentInfo: ValidPaymentInstrument(store)
        };
      };
      var controllerActions = {
        beginAddOfferOrder: beginAddOfferOrder,
        calculateAddOfferOrderQuoteWithTaxes: calculateAddOfferOrderQuoteWithTaxes,
        calculateOfferingOrderQuote: calculateOfferingOrderQuote,
        cancelOrder: cancelOrder,
        cancelStoreOrder: cancelStoreOrder,
        clearOfferingOrderQuote: clearOfferingOrderQuote,
        clearQuote: clearQuote,
        clearQuoteAndSetSelectedOffer: clearQuoteAndSetSelectedOffer,
        fetchAddresses: fetchAddresses,
        fetchAttributes: fetchAttributes,
        fetchAttributesAndNavigate: fetchAddOfferAttributesAndNavigate,
        fetchCodeTypes: fetchCodeTypes,
        fetchDecisionsAndNavigate: fetchAddOfferDecisionsAndNavigate,
        fetchWallet: fetchWallet,
        getShippingMethodsByCountryCode: getShippingMethodsByCountryCode,
        goToNextStep: goToNextStep,
        goToPreviousStep: goToPreviousStep,
        goToStep: goToStep,
        initializeAsMultiOfferWizard: initializeAsMultiOfferWizard,
        multiOfferSetCompletedSteps: multiOfferSetCompletedSteps,
        registerUnsavedChanges: registerUnsavedChanges,
        replaceMultiOfferShoppingCart: replaceMultiOfferShoppingCart,
        resetAvailableInventoryInformation: resetAvailableInventoryInformation,
        resetForContinueShopping: resetForContinueShopping,
        resetInventoryStorePickupDetails: resetInventoryStorePickupDetails,
        resetOfferAdditionalProperties: resetOfferAdditionalProperties,
        resetMobileNumberPortabilityModels: resetMobileNumberPortabilityModels,
        resetMultiOffers: resetMultiOffers,
        resetPickupId: resetPickupId,
        restoreOptionDefaultPricing: restoreOptionDefaultPricing,
        resumeOrder: resumeOrder,
        resumeOrderAttributes: resumeOrderAttributes,
        resumeStoreOrder: resumeStoreOrder,
        retrieveAvailablePaymentInstrumentTypes: retrieveAvailablePaymentInstrumentTypes,
        retrieveOffCycleNextRenewalSchedules: retrieveOffCycleNextRenewalSchedules,
        retrieveOfferingOrderQuote: retrieveOfferingOrderQuote,
        retrieveOfferingsMetadata: retrieveOfferingsMetadata,
        retrieveOrderQuote: retrieveOrderQuote,
        retrieveShoppingCartOfferings: retrieveShoppingCartOfferings,
        retrieveWalletAndSelectDefaultPaymentMethod: retrieveWalletAndSelectDefaultPaymentMethod,
        saveBulkPricing: saveBulkPricing,
        saveInventoryStorePickupDetails: saveInventoryStorePickupDetails,
        searchAttributeInventory: searchAttributeInventory,
        searchAvailableOfferings: searchAvailableOfferings,
        searchContracts: searchContracts,
        searchInventoriesAvailability: searchInventoriesAvailability,
        sendInventoryToStore: sendInventoryToStore,
        sendPortInOrItemReservation: sendPortInOrItemReservation,
        setActiveAttributeFormName: setActiveAttributeFormName,
        setAttributeFormSubmitted: setAttributeFormSubmitted,
        setChangeOfferingId: setChangeOfferingId,
        setChangeOfferingInstanceId: setChangeOfferingInstanceId,
        setCheckoutDetailsValidation: setCheckoutDetailsValidation,
        setCurrentStepIsInvalid: setCurrentStepIsInvalid,
        setCustomerAutoPayBannerFlag: setCustomerAutoPayBannerFlag,
        setCustomerCategory: setCustomerCategory,
        setDecisionsSelectedPageId: setDecisionsSelectedPageId,
        setDecisionsTouched: setDecisionsTouched,
        setDeliveryDecision: setDeliveryDecision,
        setDevicePaymentOptions: setDevicePaymentOptions,
        setDownPaymentOnMultiOfferShoppingCart: setDownPaymentOnMultiOfferShoppingCart,
        setEditAdditionalProperty: setEditAdditionalProperty,
        setEditAttributeGroups: setEditAttributeGroups,
        setEditCartAdditionalProperty: setEditCartAdditionalProperty,
        setEditCartAdditionalPropertyOnChange: setEditCartAdditionalPropertyOnChange,
        setEditOfferAdditionalProperty: setEditOfferAdditionalProperty,
        setEditOfferAdditionalPropertyOnChange: setEditOfferAdditionalPropertyOnChange,
        setEditOption: setEditOption,
        setEditOrderAdditionalProperty: setEditOrderAdditionalProperty,
        setEditOrderAdditionalPropertyOnChange: setEditOrderAdditionalPropertyOnChange,
        setEditPhysicalAttributeGroups: setEditPhysicalAttributeGroups,
        setForceShowEditFormAddress: setForceShowEditFormAddress,
        setInventoryRegionFilter: setInventoryRegionFilter,
        setInventoryStoreChangedFlag: setInventoryStoreChangedFlag,
        setIsResumingOrder: setIsResumingOrder,
        setIsResumingStoreOrder: setIsResumingStoreOrder,
        setMultiOfferShoppingCart: setMultiOfferShoppingCart,
        setPaymentInfo: setPaymentInfo,
        setRemoveOfferInstanceId: setRemoveOfferInstanceId,
        setSelectedContract: setSelectedContract,
        setSelectedFacetsEditCopy: setSelectedFacetsEditCopy,
        setSelectedInventoryStores: setSelectedInventoryStores,
        setSelectedOfferEditCopy: setSelectedOfferEditCopy,
        setSelectedOfferingChargeTypesEditCopy: setSelectedOfferingChargeTypesEditCopy,
        setSelectedOfferingInstanceId: setSelectedOfferingInstanceId,
        setSelectedTab: setSelectedTab,
        setTransferFromName: setTransferFromName,
        setTransferFromSubscriberId: setTransferFromSubscriberId,
        submitAddOrder: submitAddOrder,
        unregisterUnsavedChanges: unregisterUnsavedChanges,
        updateAttribute: updateAttribute,
        updateBillCycle: updateBillCycle,
        updateCart: updateCart,
        updateEditOptionPrice: updateEditOptionPrice,
        updateInventorySelection: updateInventorySelection,
        updateMultiOfferShoppingCart: updateMultiOfferShoppingCart,
        updateOfferPhysicalInventoryMakeAndModel: updateOfferPhysicalInventoryMakeAndModel,
        updateOfferPhysicalInventoryTypeAttribute: updateOfferPhysicalInventoryTypeAttribute,
        updatePaymentInfo: updatePaymentInfo,
        updatePortInRequest: updatePortInRequest,
        updateSelectedServiceFeatures: updateSelectedServiceFeatures,
        updateServiceTaxLocationDecision: updateServiceTaxLocationDecision,
        updateShippingDetails: updateShippingDetails,
        updateShoppingCart: updateShoppingCart,
        validateAddress: validateAddress
      };
      this.disconnectRedux = this.connectToStore(mapStateToTarget, controllerActions);
      this.checkoutStepSubmitRegistration = function (handleCheckoutStepSubmit) {
        this.checkoutStepSubmitHandler = handleCheckoutStepSubmit;
      };
      this.EditSelectedFacetIdsSelector = EditSelectedFacetIdsSelector;
      this.EditSelectedOfferingChargeTypeIdSelector = EditSelectedOfferingChargeTypeIdSelector;
      this.subscriberSubtenant = !this.state.routeParams.customerId ? [this.state.customerInfo.SubtenantId] : null;
      this.cartMessages = [this.customerCareKeys.CART_SUMMARY.QUOTE_SUMMARY];
      this.actions.beginAddOfferOrder(this.state.initializeAsMultiOfferWizard);

      // Used to see if Contracts exist if changed, also change in NewConnectWizard
      this.actions.searchContracts({
        PageNumber: 1,
        PageSize: 1
      });
      this.actions.fetchWallet(this.state.customerInfo.Id).catch(function () {
        if (_this2.state.retrieveEwalletError) {
          _this2.uiNotificationService.error(_this2.state.retrieveEwalletError.message);
        }
      });
      this.actions.fetchAddresses(this.state.customerInfo.Id);
      this.actions.setCustomerCategory(this.state.customerInfo.Category);
      this.setCustomerTypeChangeReadOnly();
      this.insufficientPermissionsWarningPopup = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.insufficientPermissionsWarningPopup = event.api;
        }
      };
      this.openInsufficientPermissionsWarningPopup = function () {
        _this2.insufficientPermissionsWarningPopup.open();
      };
      this.closeInsufficientPermissionsWarningPopup = function () {
        _this2.insufficientPermissionsWarningPopup.close();
        _this2.goBackToDashboard();
      };
      this.goBackToDashboard = function () {
        var route = DASHBOARD_ROUTE;
        var params = _this2.state.lastRoute.params || {};
        _this2.$state.go(route, params);
      };
      if (this.state.isResumingOrder) {
        this.isResumingCancelOrderButton = true;
      }
      if (this.state.isResumingOrder && !this.state.shoppingCartError || this.state.isTransferWizard || this.state.changeOfferingInstanceId) {
        this.actions.retrieveShoppingCartOfferings(this.state.customerInfo.Id).then(function (response) {
          _this2.state.offerIds.length && _this2.actions.retrieveOfferingsMetadata(_this2.state.offerIds);
          if (_this2.state.isTransferWizard) {
            var transferFromSubscriberId = pathOr(null, ['ShoppingCart', 'TransferFromSubscriberId'], response);
            if (transferFromSubscriberId) {
              _this2.actions.setTransferFromSubscriberId(transferFromSubscriberId);
              _this2.actions.setIsResumingOrder(true);
            }
          }
          if (_this2.state.isResumingOrder && response.Warnings && !!response.Warnings.find(function (warning) {
            return warning.Code === _this2.resumeOrderWarning;
          })) {
            _this2.openInsufficientPermissionsWarningPopup();
            return Promise.resolve();
          }
          if (pathOr(0, ['ShoppingCart', 'Items', 'length'], response)) {
            var physicalInventoryItemWithStore = response.ShoppingCart.Items.find(function (item) {
              return pathOr(null, ['PhysicalInventories', 0, 'StoreId'], item);
            });
            if (physicalInventoryItemWithStore) {
              _this2.actions.setSelectedInventoryStores([physicalInventoryItemWithStore.PhysicalInventories[0].StoreId.toString()]);
            }
          }
          var shoppingCartItemsForDeliveryDecisons = pathOr([], ['ShoppingCart', 'Items'], response);
          var cartContainsShippableItem = shoppingCartItemsForDeliveryDecisons.some(function (item) {
            return item.DeliveryType === DELIVERY_OPTIONS.SHIPPED;
          });
          _this2.actions.setDeliveryDecision(cartContainsShippableItem ? DELIVERY_OPTIONS.SHIPPED : DELIVERY_OPTIONS.STORE_PICKUP);
          _this2.actions.calculateOfferingOrderQuote(_this2.state.customerInfo, _this2.state.multiOfferShoppingCart, !_this2.state.currentCustomerBillCycle ? _this2.state.billCycle : null, _this2.state.executionOptions, undefined, cartContainsShippableItem, _this2.overrideBypassQuoteConfiguration).then(function () {
            if (_this2.state.asyncId) {
              _this2.repeatRetrieveQuote();
            }
            if (!_this2.state.changeOfferingInstanceId) {
              _this2.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT);
              _this2.actions.multiOfferSetCompletedSteps();
            }
          }).catch(function (error) {
            _this2.uiNotificationService.transientError(error.translatedMessage);
          });
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      }
      if (this.state.isResumingStoreOrder) {
        this.actions.resumeStoreOrder(this.state.customerInfo, false).then(function (response) {
          if (response.Warnings && !!response.Warnings.find(function (warning) {
            return warning.Code === _this2.resumeOrderWarning;
          })) {
            _this2.openInsufficientPermissionsWarningPopup();
            return Promise.resolve();
          }
        });
        this.actions.setIsResumingOrder(true);
      }
      this.additionalPropertiesPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this2.additionalPropertiesPopupApi = api;
        }
      };
      this.sendToStorePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this2.sendToStorePopupApi = api;
        }
      };

      // hook the popupApis
      this.existingCartPromptConfig = {
        onRegisterApi: function onRegisterApi(_ref3) {
          var api = _ref3.api;
          _this2.existingCartPromptApi = api;
          if (_this2.state.isExistingCart && !_this2.state.isResumingOrder && !_this2.state.initializeAsMultiOfferWizard && !_this2.state.isResumingStoreOrder && !_this2.state.isTransferWizard && !_this2.state.isTransferCart && !_this2.state.changeOfferingInstanceId) {
            _this2.$scope.$applyAsync(api.open);
          }
        }
      };
      this.unsavedChangesPromptPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref4) {
          var api = _ref4.api;
          _this2.unsavedChangesPromptPopupApi = api;
        }
      };
      this.saveOrderPromptPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref5) {
          var api = _ref5.api;
          _this2.saveOrderPromptPopupApi = api;
        }
      };
      this.saveOrderErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref6) {
          var api = _ref6.api;
          _this2.saveOrderErrorPopupApi = api;
        }
      };
      this.$scope.orderConfirmationPopup = {
        onRegisterApi: function onRegisterApi(evt) {
          _this2.$scope.orderConfirmationPopup = evt.api;
        }
      };
      this.submitOrderErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref7) {
          var api = _ref7.api;
          _this2.submitOrderErrorPopupApi = api;
        }
      };
      this.submitTransferOrderPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref8) {
          var api = _ref8.api;
          _this2.submitTransferOrderPopupApi = api;
        }
      };
      this.creditCheckPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref9) {
          var api = _ref9.api;
          _this2.creditCheckPopupApi = api;
        }
      };
      this.submitForPickupErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref10) {
          var api = _ref10.api;
          _this2.submitForPickupErrorPopupApi = api;
        }
      };
      this._previewRenewalStatementsPopupApi = null;
      this.previewRenewalStatementsPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2._previewRenewalStatementsPopupApi = event.api;
        }
      };
      this._resumeOrderErrorPopupApi = null;
      this.resumeOrderErrorPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2._resumeOrderErrorPopupApi = event.api;
        }
      };
      this.viewFullCartPopupConfig = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.viewFullCartPopupApi = event.api;
        }
      };
      this.openCreditCheckModal = function () {
        _this2.creditCheckPopupApi.open();
      };
      this.removeOfferConfirmationPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref11) {
          var api = _ref11.api;
          _this2.removeOfferConfirmationPopupApi = api;
        }
      };
      this.selectStorePopupConfig = {
        onRegisterApi: function onRegisterApi(_ref12) {
          var api = _ref12.api;
          _this2.selectStorePopupApi = api;
        }
      };
      this.storeSearchInventoryConfig = {
        onRegisterApi: function onRegisterApi(_ref13) {
          var api = _ref13.api;
          _this2.storeSearchInventoryApi = api;
        }
      };
      this.editProfileInformationPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref14) {
          var api = _ref14.api;
          _this2.editProfileInformationPopupApi = api;
        }
      };
      if (this.state.initializeAsMultiOfferWizard) {
        // This is intentionally defined after setting up all of the popup modals, so Initialize is still true.
        this.actions.retrieveShoppingCartOfferings(this.state.customerInfo.Id).then(function () {
          var contractId = (_this2.state.multiOfferShoppingCart.Items.find(function (item) {
            return item.OrderContractId;
          }) || {}).OrderContractId;
          if (contractId) {
            var selectedContract = _this2.state.contracts.find(function (contract) {
              return contract.Id === contractId;
            });
            _this2.actions.setSelectedContract(selectedContract);
          }
        }).catch(function (error) {
          _this2.uiNotificationService.transientError(error);
        }).finally(function () {
          _this2.actions.initializeAsMultiOfferWizard(false);
          _this2.actions.setSelectedOfferingChargeTypesEditCopy(_this2.state.isMultiOfferCartPrepaid ? CustomerCareKeys.OFFERING_CHARGE_TYPES.PREPAID : CustomerCareKeys.OFFERING_CHARGE_TYPES.POSTPAID, true);
        });
      }
      if (this.state.isDbss) {
        this.actions.getShippingMethodsByCountryCode(this.state.selectedCustomerHomeCountry).catch(function (error) {
          _this2.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "openSendToStorePopup",
    value: function openSendToStorePopup() {
      var _this3 = this;
      this.isLoading = false;
      this.isSendToStoreLoading = false;
      this.sendToStorePickupDetailsConfig = {
        maxDate: undefined,
        minDate: Date.now()
      };
      this.showSendToStorePopup = true;
      this.$timeout(function () {
        _this3.sendToStorePopupApi.open();
      });
    }

    //Calls retrieveOrderQuote the first time and then calls it every 30 seconds that the call hasnt returned a response
  }, {
    key: "repeatRetrieveQuote",
    value: function repeatRetrieveQuote() {
      var _this4 = this;
      asyncRepeatInterval(this.onRefreshQuote, function () {
        return !_this4.state.isAsyncComplete && _this4.state.isCheckoutStep;
      });
    }
  }, {
    key: "onRefreshQuote",
    value: function onRefreshQuote() {
      var _this5 = this;
      return this.actions.retrieveOfferingOrderQuote(this.state.customerId, this.state.asyncId).then(function (response) {
        _this5.retrieveOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        return _this5.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "onOverrideCalculateQuote",
    value: function onOverrideCalculateQuote() {
      this.overrideBypassQuoteConfiguration = true;
      this._updateShoppingCart();
    }
  }, {
    key: "repeatRetrieveOfferingQuote",
    value: function repeatRetrieveOfferingQuote() {
      var _this6 = this;
      if (this.state.offeringOrderQuote.OfferingQuotes.length > 0 && this.state.isFullCartAsyncComplete) {
        this.openViewFullCartPopupDialog();
      } else {
        asyncRepeatInterval(this.onRefreshOfferingQuote, function () {
          return !_this6.state.isFullCartAsyncComplete;
        });
      }
    }
  }, {
    key: "onRefreshOfferingQuote",
    value: function onRefreshOfferingQuote() {
      var _this7 = this;
      return this.actions.retrieveOfferingOrderQuote(this.state.customerId, this.state.asyncId).then(function (response) {
        _this7.retrieveOfferingOrderQuoteTimestamp = moment().add(RETRIEVE_ORDER_QUOTE_COUNTDOWN_DURATION, 'milliseconds');
        return response;
      }).catch(function (error) {
        return _this7.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "fetchOrderQuote",
    value: function fetchOrderQuote() {
      var _this8 = this;
      this.actions.calculateOfferingOrderQuote(this.state.customerInfo, this.state.multiOfferShoppingCart, !this.state.currentCustomerBillCycle ? this.state.billCycle : null, this.state.executionOptions, this.state.selectedShippingAddressAndMethod, undefined, this.overrideBypassQuoteConfiguration).then(function () {
        if (_this8.state.asyncId) {
          _this8.repeatRetrieveQuote();
        }
      }).catch(function (error) {
        _this8.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "sendToStore",
    value: function sendToStore() {
      var _this9 = this;
      if (this.state.isResumingStoreOrder) {
        this.isSendToStoreLoading = true;
        this.actions.cancelStoreOrder(this.state.customerInfo.Id).then(function () {
          _this9.handleSendToStore();
          _this9.isSendToStoreLoading = false;
        }).catch(function (error) {
          _this9.uiNotificationService.transientError(error.translatedMessage);
          _this9.isSendToStoreLoading = false;
        });
      } else {
        this.handleSendToStore();
      }
    }
  }, {
    key: "handleSendToStore",
    value: function handleSendToStore() {
      var _this10 = this;
      var isResumeChangeOffer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var multiOfferingInstanceId = arguments.length > 1 ? arguments[1] : undefined;
      var multiOfferingId = arguments.length > 2 ? arguments[2] : undefined;
      var isConfirmation = arguments.length > 3 ? arguments[3] : undefined;
      this.isSendToStoreLoading = true;
      this._updateShoppingCart(false, true, isConfirmation).then(function () {
        var shoppingCart = clone(Object.keys(_this10.state.shoppingCart).length ? _this10.state.shoppingCart : _this10.state.multiOfferShoppingCart);
        if (_this10.state.cartAdditionalProperties.length) {
          shoppingCart = Object.assign({}, shoppingCart, {
            AdditionalProperties: _this10.state.cartAdditionalProperties
          });
        }
        return _this10.actions.sendInventoryToStore(_this10.state.customerInfo.Id, shoppingCart, isResumeChangeOffer ? _this10.state.subscriberPhysicalInventoryPickupDetail : _this10.state.inventoryStorePickupDetails).then(function () {
          if (isResumeChangeOffer) {
            return _this10.actions.resumeStoreOrder(_this10.state.customerInfo, isResumeChangeOffer).then(function (response) {
              if (response.Warnings && !!response.Warnings.find(function (warning) {
                return warning.Code === _this10.resumeOrderWarning;
              })) {
                _this10.openInsufficientPermissionsWarningPopup();
                return Promise.resolve();
              }
              var offer = pathOr({}, ['ShoppingCart', 'Items', '0'], response);
              _this10.changeOfferClick(multiOfferingInstanceId || offer.OfferingInstanceId, multiOfferingId || offer.OfferingId);
              _this10.actions.clearQuoteAndSetSelectedOffer(null);
              _this10.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.OFFERS);
            });
          } else {
            _this10.actions.setIsResumingOrder(false);
            _this10.actions.unregisterUnsavedChanges('$ctrl.sendToStoreForm');
            _this10.onOrderActionSuccess(CustomerCareKeys.SEND_TO_STORE.SEND_SUCCESS);
          }
        }).catch(function (error) {
          if (error.Code === INVENTORY_ITEM_RESERVATION_FAULT_CODE) {
            _this10.closeSendToStorePopup();
            _this10.isInventoryItemReservationFault = true;
            _this10.openStoreSearch(true);
          } else if (error.Code === EXISTING_SAVED_CART_FOR_SEND_TO_STORE_FAULT_CODE) {
            _this10.closeSendToStorePopup();
            _this10.submitForPickupErrorPopupApi.open();
          } else {
            _this10.uiNotificationService.transientError(error.translatedMessage);
          }
        });
      }).catch(function (error) {
        _this10.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this10.isSendToStoreLoading = false;
      });
    }
  }, {
    key: "handleSubmitForPickupCancel",
    value: function handleSubmitForPickupCancel() {
      var _this11 = this;
      this.isSendToStoreLoading = true;
      this.handleSubmitForPickupErrorPopup();
      this.actions.cancelStoreOrder(this.state.customerInfo.Id).then(function () {
        _this11.handleSendToStore(false, undefined, undefined, true);
      }).catch(function (error) {
        _this11.uiNotificationService.transientError(error.translatedMessage);
      }).finally(function () {
        _this11.isSendToStoreLoading = false;
      });
    }
  }, {
    key: "handleSubmitForPickupErrorPopup",
    value: function handleSubmitForPickupErrorPopup() {
      this.submitForPickupErrorPopupApi.close();
    }
  }, {
    key: "openSaveOrderPopup",
    value: function openSaveOrderPopup() {
      var _this12 = this;
      if (this.state.cartAdditionalPropertyListMap.length) {
        this.cartAdditionalPropertyFileds = clone(this.state.cartAdditionalPropertyListMap);
        this.showAdditionalPropertiesPopup = true;
        this.$timeout(function () {
          _this12.additionalPropertiesPopupApi.open();
        });
      } else {
        this.saveOrderPromptPopupApi.open();
      }
    }
  }, {
    key: "closeAdditionalPropertiesPopup",
    value: function closeAdditionalPropertiesPopup() {
      this.showAdditionalPropertiesPopup = false;
      this.additionalPropertiesPopupApi.close();
    }
  }, {
    key: "saveAdditionalProperties",
    value: function saveAdditionalProperties() {
      if (this.additionalPropertiesPopupForm.$valid) {
        this.showAdditionalPropertiesPopup = false;
        this.additionalPropertiesPopupApi.close();
        this.saveOrderPromptPopupApi.open();
      } else {
        var old = this.$location.hash();
        this.$location.hash('additionalPropertiesErrorField');
        this.$anchorScroll();
        this.$location.hash(old);
      }
    }
  }, {
    key: "onCartAdditionalPropertyListUpdated",
    value: function onCartAdditionalPropertyListUpdated() {
      this.actions.setEditCartAdditionalProperty(this.state.cartAdditionalPropertyListMap);
    }
  }, {
    key: "onCartAdditionalPropertyChanged",
    value: function onCartAdditionalPropertyChanged(id, newValue) {
      this.actions.setEditCartAdditionalPropertyOnChange(id, newValue);
    }
  }, {
    key: "onAdditionalPropertyListUpdated",
    value: function onAdditionalPropertyListUpdated(isOfferAdditionalProperty) {
      if (isOfferAdditionalProperty) {
        this.actions.setEditOfferAdditionalProperty(this.state.offerAdditionalPropertyListMap);
      } else {
        this.actions.setEditOrderAdditionalProperty(this.state.orderAdditionalPropertyListMap);
      }
    }
  }, {
    key: "onAdditionalPropertyChanged",
    value: function onAdditionalPropertyChanged(id, newValue, isOfferAdditionalProperty) {
      if (isOfferAdditionalProperty) {
        this.actions.setEditOfferAdditionalPropertyOnChange(id, newValue);
      } else {
        this.actions.setEditOrderAdditionalPropertyOnChange(id, newValue);
      }
    }
  }, {
    key: "openRemoveOfferConfirmation",
    value: function openRemoveOfferConfirmation() {
      this.removeOfferConfirmationPopupApi.open();
    }
  }, {
    key: "closeRemoveOfferConfirmation",
    value: function closeRemoveOfferConfirmation() {
      this.removeOfferConfirmationPopupApi.close();
    }
  }, {
    key: "resumeOrderErrorCallback",
    value: function resumeOrderErrorCallback() {
      this._resumeOrderErrorPopupApi.open();
    }
  }, {
    key: "closeResumeOrderErrorPopup",
    value: function closeResumeOrderErrorPopup() {
      this._resumeOrderErrorPopupApi.close();
    }
  }, {
    key: "cancelButtonText",
    value: function cancelButtonText() {
      return this.isResumingCancelOrderButton && !this.state.shoppingCartError ? i18n.translate(CustomerCareKeys.CANCEL_RESUME) : i18n.translate(CustomerCareKeys.CANCEL_ORDER);
    }
  }, {
    key: "handleCloseSaveOrderErrorPopup",
    value: function handleCloseSaveOrderErrorPopup() {
      this.saveOrderErrorPopupApi.close();
    }
  }, {
    key: "handleResultExistingCartPromptPopup",
    value: function handleResultExistingCartPromptPopup(confirmed) {
      if (confirmed) {
        this.isCartExisting = true;
        this.actions.setIsResumingOrder(true);
        this.$state.reload();
      }
      this.existingCartPromptApi.close();
    }
  }, {
    key: "handleCloseExistingCartPromptPopup",
    value: function handleCloseExistingCartPromptPopup() {
      this.existingCartPromptApi.close();
    }
  }, {
    key: "handleResultUnsavedChangesPromptPopup",
    value: function handleResultUnsavedChangesPromptPopup(confirmed) {
      if (confirmed) {
        this.fullCartEditOfferingInstanceId ? this.handleEditOffer(this.fullCartEditOfferingInstanceId) : this.handleCancel();
      } else {
        this.fullCartEditOfferingInstanceId = null;
      }
      this.unsavedChangesPromptPopupApi.close();
    }
  }, {
    key: "openViewFullCartPopupDialog",
    value: function openViewFullCartPopupDialog() {
      this.showViewFullCartPopup = true;
      this.$timeout(this.viewFullCartPopupApi.open);
    }
  }, {
    key: "onViewFullCartRequest",
    value: function onViewFullCartRequest() {
      var _this13 = this;
      if (this.state.asyncId && this.state.isCheckoutStep) {
        this.repeatRetrieveOfferingQuote();
        this.openViewFullCartPopupDialog();
      } else {
        if (!Object.keys(this.state.offeringOrderQuote).length) {
          this.actions.calculateOfferingOrderQuote(this.state.customerInfo, this.state.multiOfferShoppingCart, !this.state.currentCustomerBillCycle ? this.state.billCycle : null, this.state.executionOptions, this.state.selectedShippingAddressAndMethod).then(function () {
            if (_this13.state.cartContainsOffcycleOffer || _this13.state.multiOfferCartContainsOfferWithAtleastOneBillerRuleCycleLevelAsItem) {
              _this13.actions.retrieveOffCycleNextRenewalSchedules(_this13.state.customerInfo.Id, _this13.state.multiOfferShoppingCart.Items).catch(function (error) {
                _this13.uiNotificationService.transientError(error.translatedMessage);
              });
            }
            if (_this13.state.asyncId) {
              _this13.repeatRetrieveOfferingQuote();
            }
            _this13.openViewFullCartPopupDialog();
          }).catch(function (error) {
            _this13.uiNotificationService.transientError(error.translatedMessage);
          });
        } else {
          if (this.state.cartContainsOffcycleOffer || this.state.multiOfferCartContainsOfferWithAtleastOneBillerRuleCycleLevelAsItem) {
            this.actions.retrieveOffCycleNextRenewalSchedules(this.state.customerInfo.Id, this.state.multiOfferShoppingCart.Items).catch(function (error) {
              _this13.uiNotificationService.transientError(error.translatedMessage);
            });
          }
          if (this.state.asyncId) {
            this.repeatRetrieveOfferingQuote();
          }
          this.openViewFullCartPopupDialog();
        }
      }
    }
  }, {
    key: "closeSendToStorePopup",
    value: function closeSendToStorePopup() {
      this.showSendToStorePopup = false;
      this.sendToStorePopupApi.close();
    }
  }, {
    key: "closeViewFullCartPopupDialog",
    value: function closeViewFullCartPopupDialog() {
      this.showViewFullCartPopup = false;
      this.viewFullCartPopupApi.close();
    }
  }, {
    key: "handleCloseUnsavedChangesPromptPopup",
    value: function handleCloseUnsavedChangesPromptPopup() {
      this.unsavedChangesPromptPopupApi.close();
    }
  }, {
    key: "handleResultSaveOrderPromptPopup",
    value: function handleResultSaveOrderPromptPopup(confirmed) {
      var _this14 = this;
      this.saveOrderPromptPopupApi.close();
      if (confirmed) {
        if (this.state.isAttributesStep) {
          this.finishAttributes(false, true);
        } else if (this.state.isCheckoutStep) {
          if (this.state.cartAdditionalProperties.length) {
            var shoppingCart = Object.assign({}, this.state.multiOfferShoppingCart, {
              AdditionalProperties: this.state.cartAdditionalProperties
            });
            this.actions.updateShoppingCart(this.state.customerInfo.Id, shoppingCart).then(function () {
              _this14.onOrderActionSuccess(CustomerCareKeys.SAVE_ORDER_SUCCESS);
            }).catch(function (error) {
              _this14.saveOrderErrorMessage = error.translatedMessage;
              _this14.saveOrderErrorPopupApi.open();
            });
          } else {
            this.actions.updateShoppingCart(this.state.customerInfo.Id, this.state.multiOfferShoppingCart).then(function () {
              _this14.onOrderActionSuccess(CustomerCareKeys.SAVE_ORDER_SUCCESS);
            }).catch(function (error) {
              _this14.saveOrderErrorMessage = error.translatedMessage;
              _this14.saveOrderErrorPopupApi.open();
            });
          }
        }
      }
      this.saveOrderPromptPopupApi.close();
    }
  }, {
    key: "handleCloseSaveOrderPromptPopup",
    value: function handleCloseSaveOrderPromptPopup() {
      this.saveOrderPromptPopupApi.close();
    }
  }, {
    key: "openOrderConfirmationPopup",
    value: function openOrderConfirmationPopup() {
      this.$scope.orderConfirmationPopup.open();
    }
  }, {
    key: "handleCloseSubmitOrderErrorPopup",
    value: function handleCloseSubmitOrderErrorPopup() {
      this.submitOrderErrorPopupApi.close();
    }
  }, {
    key: "handleResultTransferOrderPopup",
    value: function handleResultTransferOrderPopup() {
      this.$element.find('button[type="submit"]')[0].focus();
      this.$timeout(this.attemptNextStep);
      this.handleCloseSubmitTransferOrderPopup();
    }
  }, {
    key: "handleCloseSubmitTransferOrderPopup",
    value: function handleCloseSubmitTransferOrderPopup() {
      this.submitTransferOrderPopupApi.close();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      var _this15 = this;
      this.isLoading = true;
      this.actions.cancelOrder();
      if (!this.isResumingCancelOrderButton && !this.state.isResumingStoreOrder) {
        this.isRemovingOffer = true;
        this.actions.updateShoppingCart(this.state.customerId, {}).catch(function (error) {
          _this15.uiNotificationService.transientError(error.translatedMessage);
        }).finally(function () {
          _this15.isRemovingOffer = false;
        });
      }
      this.actions.setIsResumingOrder(false);
      this.actions.setIsResumingStoreOrder(false);
      this.deregisterUnsavedChanges();
      if (this.state.lastRoute.name && this.state.lastRoute.name !== STATE_OR_NAME && this.state.lastRoute.params.customerId === this.state.customerId) {
        this.$state.go(this.state.lastRoute.name, this.state.lastRoute.params);
      } else {
        this.redirectToCustomer();
      }
    }
  }, {
    key: "onOrderActionSuccess",
    value: function onOrderActionSuccess(messageKey) {
      this.uiNotificationService.transientSuccess(i18n.translate(messageKey));
      this.redirectToCustomer();
    }
  }, {
    key: "deregisterUnsavedChanges",
    value: function deregisterUnsavedChanges() {
      this.actions.unregisterUnsavedChanges('addOfferWizard');
      this.actions.resetMobileNumberPortabilityModels();
    }
  }, {
    key: "searchAvailableOfferings",
    value: function searchAvailableOfferings() {
      var data = {
        ContractId: this.state.selectedContract ? this.state.selectedContract.Id : undefined,
        CurrencyCode: this.state.customerInfo.SubscriberCurrency,
        Facets: [],
        OfferingChargeType: null,
        OrderScenario: ORDER_SCENARIOS.ADD_OFFER,
        PageNumber: 1,
        PageSize: this.state.pageSize,
        SearchString: '',
        SortBy: OFFERINGS_SEARCH_CONSTANTS.SORT_BY.RELEVANCE,
        SortDirection: OFFERINGS_SEARCH_CONSTANTS.SORT_DIRECTION.DESCENDING
      };
      if (this.subscriberSubtenant) {
        data['Subtenants'] = this.subscriberSubtenant;
      }
      return this.actions.searchAvailableOfferings(data, {
        pageNumber: 1
      }, undefined, this.state.routeParams.customerId);
    }
  }, {
    key: "onItemDownpaymentChanged",
    value: function onItemDownpaymentChanged(item) {
      this.actions.setDownPaymentOnMultiOfferShoppingCart(item);
    }
  }, {
    key: "onOfferSelected",
    value: function onOfferSelected(offerId) {
      var _this16 = this;
      if (!this.state.changeOfferingInstanceId) {
        if (this.state.isResumingOrder) {
          this.actions.setIsResumingOrder(false);
        }
        if (this.state.isResumingStoreOrder) {
          this.actions.setIsResumingStoreOrder(false);
        }
      }
      this.actions.fetchDecisionsAndNavigate({
        offerId: offerId,
        customer: this.state.customerInfo,
        isConvergentBiller: this.state.isConvergentBiller,
        segmentationContext: [],
        shouldCalculateTaxes: !this.state.isDbss && !!this.state.validPaymentInfo,
        paymentInstrument: [this.state.validPaymentInfo],
        isMultiOfferEditing: this.state.isMultiOfferEditing,
        multiOfferShoppingCart: this.state.multiOfferShoppingCart,
        isDbss: this.state.isDbss,
        changeOfferingInstanceId: this.state.changeOfferingInstanceId,
        pickupId: this.state.pickupId
      }).then(function () {
        _this16.actions.retrieveOfferingsMetadata([offerId]).catch(function (error) {
          _this16.uiNotificationService.transientError(error.translatedMessage);
        });
        _this16.wizardForm.$setPristine();
      });
    }
  }, {
    key: "onOfferingDeselected",
    value: function onOfferingDeselected() {
      if (this.state.isResumingOrder) {
        this.actions.setIsResumingOrder(false);
      }
    }
  }, {
    key: "goToPreviousStep",
    value: function goToPreviousStep() {
      if (this.state.isCheckoutStep) {
        this.actions.setPaymentInfo(this.state.paymentInfoEdit);
      }
      if (this.state.isAttributesStep && this.isAttributesFormInvalid()) {
        this.wizardForm.$setSubmitted();
        this.actions.setAttributeFormSubmitted(true);
        return;
      }
      this.actions.goToPreviousStep();
      if (this.state.isDecisionsStep) {
        this.actions.setAttributeFormSubmitted(false);
        this.actions.setActiveAttributeFormName(null);
      }
      if (this.state.isOffersStep) {
        this.actions.setSelectedOfferingChargeTypesEditCopy(this.state.isMultiOfferCartPrepaid ? CustomerCareKeys.OFFERING_CHARGE_TYPES.PREPAID : CustomerCareKeys.OFFERING_CHARGE_TYPES.POSTPAID, true);
      }
    }
  }, {
    key: "cancelClick",
    value: function cancelClick() {
      if (this.unsavedChangesPrompt.hasUnsavedChanges()) {
        this.unsavedChangesPromptPopupApi.open();
      } else {
        this.handleCancel();
      }
    }
  }, {
    key: "isAttributesFormInvalid",
    value: function isAttributesFormInvalid() {
      return this.wizardForm['attributesController.attributesForm'] && this.wizardForm['attributesController.attributesForm'].$invalid || !this.state.allAttributesAreValid;
    }
  }, {
    key: "isCheckoutFormInvalid",
    value: function isCheckoutFormInvalid() {
      return this.wizardForm['$ctrl.paymentInstrumentForm'] && this.wizardForm['$ctrl.paymentInstrumentForm'].$invalid;
    }
  }, {
    key: "onStepSubmit",
    value: function onStepSubmit() {
      if (this.state.isCheckoutStep) {
        this.checkoutStepSubmitHandler();
      }
    }
  }, {
    key: "onSubmit",
    value: function onSubmit() {
      if (!this.state.isSubmittingOrder) {
        if (this.state.isTransferWizard && this.state.isCheckoutStep) {
          this.submitTransferOrderPopupApi.open();
        } else {
          this.$element.find('button[type="submit"]')[0].focus();
          this.$timeout(this.attemptNextStep);
        }
      }
    }
  }, {
    key: "handleSearchInventoryAvabilityResolve",
    value: function handleSearchInventoryAvabilityResolve(isContinueShopping, isSaveOrder, isSendToStore) {
      if (!this.state.isAllSelectedPhysicalInventoryAvailable) {
        if (this.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
          this.uiNotificationService.transientError(i18n.translate(this.customerCareKeys.ATTRIBUTES.UNAVAILABLE_SHIPPING_INVENTORY));
        } else {
          this.openStoreSearch();
        }
      } else if (isSaveOrder) {
        this.openSaveOrderPopup();
      } else if (isSendToStore) {
        this.openSendToStorePopup();
      } else {
        this.finishAttributes(isContinueShopping);
      }
      this.wizardForm.$setPristine();
    }
  }, {
    key: "getCompletedDecisions",
    value: function getCompletedDecisions() {
      return [].concat(_toConsumableArray(this.state.serviceTaxDecisions), _toConsumableArray(this.state.formattedDeliveryDecisions), _toConsumableArray(this.state.completedDecisions));
    }
  }, {
    key: "handleAttributeValidations",
    value: function handleAttributeValidations() {
      var _this17 = this;
      var isContinueShopping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isSaveOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isSendToStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var isSearchInventoryAvabilityComplete = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      this.actions.setAttributeFormSubmitted(true);
      if (!this.isAttributesFormInvalid() && !duplicatedServiceIdentifierAttributes(this.state.formAttributeGroups).length) {
        this.actions.fetchAttributes({
          offeringId: this.state.selectedOfferId,
          offeringInstanceId: this.state.selectedOfferingInstanceId,
          completedDecisions: this.getCompletedDecisions(),
          completedAttributes: this.state.formattedAttributes,
          completedPhysicalAttributes: this.state.formattedPhysicalAttributes,
          isConvergentBiller: true,
          isReconnectAction: false,
          changeOfferingInstanceId: this.state.changeOfferingInstanceId,
          useSavedShoppingCart: this.state.isResumingOrder,
          pickupId: this.state.pickupId
        }).then(function () {
          if (_this17.state.formattedPhysicalAttributes.length) {
            //we are not using customerInfoEdit since we do not need to worry about editing customer information since this is not new-connect flow
            _this17.actions.resetAvailableInventoryInformation();
            _this17.actions.fetchAttributes({
              offeringId: _this17.state.selectedOfferId,
              offeringInstanceId: _this17.state.selectedOfferingInstanceId,
              completedDecisions: _this17.getCompletedDecisions(),
              completedAttributes: _this17.state.formattedAttributes,
              completedPhysicalAttributes: _this17.state.formattedPhysicalAttributes,
              isConvergentBiller: _this17.state.isConvergentBiller,
              isReconnectAction: false,
              changeOfferingInstanceId: _this17.state.changeOfferingInstanceId,
              useSavedShoppingCart: _this17.state.isResumingOrder,
              pickupId: _this17.state.pickupId
            }).then(function () {
              _this17.storeSearchSettings = {
                isContinueShopping: isContinueShopping,
                isSaveOrder: isSaveOrder,
                isSendToStore: isSendToStore
              };
              if (_this17.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED) {
                _this17.actions.setInventoryRegionFilter(_this17.state.dbssShippingEnabledRegionId);
              }
              if (_this17.state.selectedInventoryStores.length < 1 && !_this17.state.isTransferWizard) {
                _this17.openStoreSearch();
                _this17.wizardForm.$setPristine();
                _this17.isLoading = false;
              } else if (!_this17.state.isTransferWizard) {
                if (isSearchInventoryAvabilityComplete) {
                  _this17.handleSearchInventoryAvabilityResolve(isContinueShopping, isSaveOrder, isSendToStore);
                } else {
                  _this17.actions.searchInventoriesAvailability(_this17.state.formattedPhysicalInventories).then(function () {
                    _this17.handleSearchInventoryAvabilityResolve(isContinueShopping, isSaveOrder, isSendToStore);
                  }).catch(function (err) {
                    _this17.showStoreInventoryPopup = true;
                    _this17.$timeout(function () {
                      _this17.storeSearchInventoryApi.open();
                      _this17.onSearchInventoryAvailabilityFailure(err);
                    });
                  });
                }
              } else {
                _this17.finishAttributes(isContinueShopping);
              }
            });
          } else if (isSaveOrder) {
            _this17.openSaveOrderPopup();
          } else if (isSendToStore) {
            _this17.openSendToStorePopup();
          } else {
            _this17.finishAttributes(isContinueShopping);
          }
        }).catch(function (error) {
          if (error.Code !== DUPLICATE_SERVICE_IDENTIFIER_FAULT_CODE) {
            _this17.uiNotificationService.transientError(error.translatedMessage);
          }
        });
      }
    }
  }, {
    key: "finishAttributes",
    value: function finishAttributes() {
      var _this18 = this;
      var isContinueShopping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isSaveOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (isContinueShopping) {
        if (this.state.changeOfferingInstanceId) {
          this.resetChange();
        }
        this.addAnotherOffer();
      } else {
        this._updateShoppingCart(isSaveOrder).then(function (reduxActionsStatuses) {
          if (reduxActionsStatuses.isMultiOfferCartUpdated) {
            if (isSaveOrder) {
              _this18.onOrderActionSuccess(CustomerCareKeys.SAVE_ORDER_SUCCESS);
            }
          }
          if (reduxActionsStatuses.isQuoteRefreshed) {
            _this18.actions.setSelectedOfferingInstanceId(null);
            _this18.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT);
          }
        });
      }
      this.wizardForm.$setPristine();
    }
  }, {
    key: "updateCart",
    value: function updateCart(offerId, offeringInstanceId, completedDecisions, isModify, customerId, callback, contextOfferingAction, transitionContext, isConvergentBiller, customerLanguage) {
      this.actions.setDevicePaymentOptions([]);
      this.actions.setDecisionsTouched(true);
      this.actions.updateCart(offerId, offeringInstanceId, completedDecisions, isModify, customerId, callback, contextOfferingAction, transitionContext, isConvergentBiller, customerLanguage, this.state.pickupId, this.state.changeOfferingInstanceId, this.state.isResumingOrder);
    }
  }, {
    key: "addAnotherOffer",
    value: function addAnotherOffer() {
      var _this19 = this;
      this.actions.setIsResumingOrder(false);
      if (this.state.isCheckoutStep && this.state.isMultiOffer) {
        this.actions.resetForContinueShopping();
        if (this.state.isMultiOfferEditing) {
          this.resetEditingMultiOffer();
        }
        this.actions.clearQuote();
        this.actions.setSelectedOfferingChargeTypesEditCopy(this.state.isMultiOfferCartPrepaid ? CustomerCareKeys.OFFERING_CHARGE_TYPES.PREPAID : CustomerCareKeys.OFFERING_CHARGE_TYPES.POSTPAID, true);
      } else {
        var shoppingCart = this.state.isMultiOfferEditing || this.state.changeOfferingInstanceId ? this.state.editedMultiOfferShoppingCart : this.state.isCheckoutStep ? this.state.multiOfferShoppingCart : this.state.shoppingCart;
        return this.actions.updateMultiOfferShoppingCart(this.state.customerId, shoppingCart, this.state.isMultiOffer && !(this.state.isMultiOfferEditing || this.state.changeOfferingInstanceId)).then(function () {
          _this19.actions.clearOfferingOrderQuote();
          _this19.actions.retrieveShoppingCartOfferings(_this19.state.customerId).then(function () {
            _this19.deregisterUnsavedChanges();
            _this19.actions.resetForContinueShopping();
            if (_this19.state.changeOfferingInstanceId) {
              _this19.resetChange();
            }
            if (_this19.state.isMultiOfferEditing) {
              _this19.resetEditingMultiOffer();
            }
            _this19.actions.clearQuote();
            _this19.actions.setSelectedOfferingChargeTypesEditCopy(_this19.state.isMultiOfferCartPrepaid ? CustomerCareKeys.OFFERING_CHARGE_TYPES.PREPAID : CustomerCareKeys.OFFERING_CHARGE_TYPES.POSTPAID, true);
          }).catch(function (error) {
            _this19.uiNotificationService.transientError(error.translatedMessage);
          });
        }).catch(function (error) {
          _this19.saveOrderErrorPopupApi.open(error);
        });
      }
    }
  }, {
    key: "resetEditingMultiOffer",
    value: function resetEditingMultiOffer() {
      this.actions.setSelectedOfferingInstanceId(null);
      this.actions.setDecisionsSelectedPageId(null);
    }
  }, {
    key: "changeOfferClick",
    value: function changeOfferClick(offeringInstanceId, offeringId) {
      var _this20 = this;
      if (this.state.isMultiOffer) {
        if (this.state.isResumingStoreOrder) {
          this.handleResumeSendToStoreChangeOfferClick(offeringInstanceId, offeringId);
        } else {
          this.actions.resetForContinueShopping();
        }
        this.actions.clearQuote();
        this.actions.setChangeOfferingId(offeringId);
        this.actions.setChangeOfferingInstanceId(offeringInstanceId);
      } else {
        this.isLoading = true;
        this.actions.updateMultiOfferShoppingCart(this.state.customerInfo.Id, this.state.multiOfferShoppingCart, false).then(function (response) {
          return _this20.actions.retrieveShoppingCartOfferings(_this20.state.customerInfo.Id).then(function () {
            return _this20.changeOfferClick(response.ShoppingCart.Items[0].OfferingInstanceId, offeringId);
          });
        }).catch(function (error) {
          return _this20.uiNotificationService.transientError(error.translatedMessage);
        }).finally(function () {
          _this20.isLoading = false;
        });
      }
      if (this.state.selectedShippingAddressAndMethod) {
        this.actions.updateShippingDetails({});
      }
    }
  }, {
    key: "handleSingleOfferChange",
    value: function handleSingleOfferChange() {
      var _this21 = this;
      if (this.state.isResumingStoreOrder) {
        this.handleResumeSendToStoreChangeOfferClick();
      } else {
        this.actions.updateShoppingCart(this.state.customerInfo.Id, this.state.shoppingCart).then(function (response) {
          var offer = pathOr(null, ['ShoppingCart', 'Items', '0'], response);
          if (offer) {
            _this21.changeOfferClick(offer.OfferingInstanceId, offer.OfferingId);
            _this21.actions.clearQuoteAndSetSelectedOffer(null);
            _this21.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.OFFERS);
          }
        });
      }
    }
  }, {
    key: "handleResumeSendToStoreChangeOfferClick",
    value: function handleResumeSendToStoreChangeOfferClick(offeringInstanceId, offeringId) {
      var _this22 = this;
      this.actions.cancelStoreOrder(this.state.customerInfo.Id).then(function () {
        _this22.handleSendToStore(true, offeringInstanceId, offeringId);
        _this22.actions.resetForContinueShopping();
      }).catch(function (error) {
        _this22.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "editOfferClick",
    value: function editOfferClick(offeringInstanceId) {
      var _this23 = this;
      if (this.state.isMultiOffer) {
        this.fullCartEditOfferingInstanceId = offeringInstanceId;
        if (this.unsavedChangesPromptPopupApi && !this.state.isCheckoutStep) {
          // TODO: CustomerOrder - should update this to be handled more intelligently (if something is modified)
          // which means unsavedChanges will have to be reworked for the add offer flow.
          this.unsavedChangesPromptPopupApi.open();
        } else {
          this.handleEditOffer();
        }
      } else {
        this.isLoading = true;
        this.actions.updateMultiOfferShoppingCart(this.state.customerInfo.Id, this.state.multiOfferShoppingCart, false).then(function (response) {
          return _this23.actions.retrieveShoppingCartOfferings(_this23.state.customerInfo.Id).then(function () {
            return _this23.editOfferClick(response.ShoppingCart.Items[0].OfferingInstanceId);
          });
        }).catch(function (error) {
          return _this23.uiNotificationService.transientError(error.translatedMessage);
        }).finally(function () {
          _this23.isLoading = false;
        });
      }
      if (this.state.editModalSideNavList) {
        this.actions.setCheckoutDetailsValidation([]);
      }
      if (this.state.selectedShippingAddressAndMethod) {
        this.actions.updateShippingDetails({});
      }
    }
  }, {
    key: "handleEditOffer",
    value: function handleEditOffer() {
      var _this24 = this;
      if (this.showViewFullCartPopup) {
        this.closeViewFullCartPopupDialog();
      }
      this.actions.resetForContinueShopping();
      this.actions.clearQuote();
      this.actions.setIsResumingOrder(true);
      this.actions.setSelectedOfferingInstanceId(this.fullCartEditOfferingInstanceId);
      this.actions.setDecisionsSelectedPageId(null);
      this.actions.resumeOrder(this.state.currentCustomer, this.resumeOrderErrorCallback, this.state.isConvergentBiller, !this.state.isDbss && !!this.state.validPaymentInfo, [this.state.validPaymentInfo], this.fullCartEditOfferingInstanceId, this.state.isMultiOfferEditing, this.state.pickupId).finally(function () {
        _this24.fullCartEditOfferingInstanceId = null;
      });
    }
  }, {
    key: "handleRemoveOffer",
    value: function handleRemoveOffer(offeringInstanceId) {
      this.actions.setRemoveOfferInstanceId(offeringInstanceId);
      // From checkout step we know this is remove offer that has been saved into shopping cart with an offer instance id
      if (this.state.isCheckoutStep) {
        if (this.state.offersCount > 1) {
          this.openRemoveOfferConfirmation();
        } else {
          this.unsavedChangesPromptPopupApi.open(); //In the future we shouldn't use unsavedChangesPromptPopup, create a different popup with a different message .
        }
      } else if (this.state.isMultiOfferEditing) {
        // If we are editing an offer we also know that it has been saved into shopping cart with an offer instance id
        this.state.offersCount > 1 ? this.openRemoveOfferConfirmation() : this.unsavedChangesPromptPopupApi.open(); //In the future we shouldn't use unsavedChangesPromptPopup, create a different popup with a different message .
      } else {
        //You are in the middle of adding an unsaved offer but you are removing a previous offer
        this.openRemoveOfferConfirmation();
      }
    }
  }, {
    key: "removeOffer",
    value: function removeOffer(confirm) {
      var _this25 = this;
      if (confirm) {
        if (this.showViewFullCartPopup) {
          this.closeViewFullCartPopupDialog();
        }
        this.isRemovingOffer = true;
        if (!this.state.isCheckoutStep && !this.state.isRemovingOfferSavedToMultiOfferCart) {
          this.cancelAddingOrEditingOffer();
        } else {
          this.actions.updateShoppingCart(this.state.customerId, this.state.shoppingCartWithoutRemovedOffer).then(function () {
            _this25.actions.setIsResumingOrder(false); // Needed to prevent the handle cancel from thinking its still in resume
            _this25.actions.clearOfferingOrderQuote();
            return _this25.actions.retrieveShoppingCartOfferings(_this25.state.customerInfo.Id).then(function () {
              if (_this25.state.isCheckoutStep) {
                return _this25.actions.calculateOfferingOrderQuote(_this25.state.customerInfo, _this25.state.multiOfferShoppingCart, undefined, undefined, undefined, undefined, _this25.overrideBypassQuoteConfiguration).then(function () {
                  if (_this25.state.asyncId) {
                    _this25.repeatRetrieveQuote();
                  }
                }).catch(function (error) {
                  _this25.uiNotificationService.transientError(error.translatedMessage);
                });
              }
            }).catch(function (error) {
              _this25.uiNotificationService.transientError(error.translatedMessage);
            });
          }).catch(function (error) {
            _this25.uiNotificationService.transientError(error.translatedMessage);
          }).finally(function () {
            _this25.actions.setRemoveOfferInstanceId(null);
            _this25.isRemovingOffer = false;
          });
        }
      } else {
        this.actions.setRemoveOfferInstanceId(null);
      }
      this.closeRemoveOfferConfirmation();
    }
  }, {
    key: "cancelAddingOrEditingOffer",
    value: function cancelAddingOrEditingOffer() {
      var _this26 = this;
      // Go to checkout step and set the step progress bar with previous steps completed with no skipped steps
      this.actions.setSelectedOfferingInstanceId(null);
      this.actions.setDecisionsSelectedPageId(null);
      if (this.state.changeOfferingInstanceId) {
        this.resetChange();
      }
      if (this.state.pickupId) {
        this.actions.resumeStoreOrder(this.state.customerInfo, false, this.overrideBypassQuoteConfiguration).then(function (response) {
          if (response.Warnings && !!response.Warnings.find(function (warning) {
            return warning.Code === _this26.resumeOrderWarning;
          })) {
            _this26.openInsufficientPermissionsWarningPopup();
            return Promise.resolve();
          }
        });
      } else {
        this.actions.retrieveShoppingCartOfferings(this.state.customerInfo.Id).then(function (response) {
          _this26.actions.clearQuote();
          return _this26.actions.calculateOfferingOrderQuote(_this26.state.customerInfo, response.ShoppingCart, undefined, undefined, undefined, undefined, _this26.overrideBypassQuoteConfiguration).then(function () {
            if (_this26.state.asyncId) {
              _this26.repeatRetrieveQuote();
            }
            _this26.actions.goToStep(CustomerCareKeys.WIZARD.STEPS.CHECKOUT);
            _this26.actions.multiOfferSetCompletedSteps();
          }).catch(function (error) {
            _this26.uiNotificationService.transientError(error.translatedMessage);
          });
        }).catch(function (error) {
          _this26.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "attemptNextStep",
    value: function attemptNextStep() {
      var _this27 = this;
      var isContinueShopping = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isSendToStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (this.state.isSavingOrder || this.state.isCalculatingQuote || this.state.isSubmittingOrder || this.state.isRetrievingMultiOfferCart || this.state.isSendingInventoryToStore || this.isLoading || this.state.isFetchingAnyData) {
        return;
      }
      // isContinueShopping uses the logic that already exists in step navigation and validations.
      var dirty = true;
      // NOTE: this may register non-existant (extraneous) "unsaved
      // changes" in the case that the user tries to proceed to the next
      // step, but has not dirtied the form
      this.actions.registerUnsavedChanges('addOfferWizard', {
        isDirty: function isDirty() {
          return dirty;
        },
        setPristine: function setPristine() {
          dirty = false;
        }
      });
      if (this.state.isOffersStep) {
        if (!this.state.currentStepIsInvalid) {
          this.actions.goToNextStep();
          this.wizardForm.$setPristine();
        }
      } else if (this.state.isAttributesStep && !this.state.hasRequiredAndUnavailableInventory) {
        this.handleAttributeValidations(isContinueShopping, false, isSendToStore);
      } else if (this.state.isCheckoutStep) {
        if (isContinueShopping) {
          // This will need to be changed as ASCFTR-2830 progresses.
          this.addAnotherOffer();
          this.actions.resetOfferAdditionalProperties();
        } else if (isSendToStore) {
          this.openSendToStorePopup();
        } else {
          if (!this.isCheckoutFormInvalid()) {
            this.validateAddressWithAPI().then(function () {
              var addressKey = _this27.getAddressKey();
              var validatedAddress = _this27.state.validatedAddresses[addressKey];
              if (!addressKey || validatedAddress && isAddressValidFromAddressResponse(validatedAddress)) {
                var paymentInfo;
                // if statement handled this way to make sure it has an Id, otherwise it returns a function if null
                if (pathOr(false, ['Id'], _this27.state.selectedPayment)) {
                  paymentInfo = _this27.state.supplyPaymentInstrument || _this27.state.paymentInstrumentRequired ? _this27.state.selectedPaymentClean : null;
                } else {
                  _this27.actions.setPaymentInfo(_this27.state.paymentInfoEdit);
                  paymentInfo = _this27.state.paymentInfo;
                  if (_this27.state.paymentInfo && _this27.state.paymentInfo.BillingAddressIsServiceAddress) {
                    paymentInfo = Object.assign({}, paymentInfo, {
                      BillingAddressId: _this27.state.serviceAddress.Id
                    });
                  }
                  if (_this27.state.paymentInfo && !_this27.state.paymentInfo.BillingAddressIsServiceAddress) {
                    var billingAddress = Object.assign({}, paymentInfo.BillingAddress, {
                      Name: _this27.state.paymentInfo.BillingAddress.LineOne // Name is required by the API and needs to be unique.
                    });
                    paymentInfo = Object.assign({}, paymentInfo, {
                      BillingAddress: billingAddress
                    });
                  }
                }
                var billCycle = !_this27.state.currentCustomerBillCycle ? _this27.state.billCycle : null;
                _this27.actions.setCustomerAutoPayBannerFlag(_this27.state.selectedPaymentMethodAutoPay);
                if (_this27.state.currentCustomerCreditLimit) {
                  _this27.checkCreditAndFinanceLimitAndSubmitOrder(billCycle, _this27.state.multiOfferShoppingCart, paymentInfo);
                } else {
                  _this27.addOfferSubmitOrder(billCycle, _this27.state.multiOfferShoppingCart, paymentInfo);
                }
              } else {
                _this27.actions.setForceShowEditFormAddress(false);
                _this27.uiNotificationService.transientError(i18n.translate(_this27.customerCareKeys.ADDRESS_COMPONENT.INVALID_ADDRESS_ERROR_MESSAGE));
              }
            }).catch(function (err) {
              _this27.uiNotificationService.transientError(err.translatedMessage);
            });
          }
        }
      } else if (!this.state.currentStepIsInvalid) {
        if (this.state.isDecisionsStep && !this.state.hasDecisionValidationError) {
          if ((this.state.isResumingOrder && !this.state.shoppingCartError || this.state.isResumingStoreOrder) && !this.state.changeOfferingInstanceId && !this.state.isMultiOfferEditing) {
            this.actions.resumeOrderAttributes(this.state.customerId, this.state.isConvergentBiller, false, this.state.selectedOfferingInstanceId, this.state.pickupId, this.state.completedDecisions, this.state.selectedOfferId).then(function () {
              return _this27.actions.updateCart(_this27.state.selectedOfferId, _this27.state.selectedOfferingInstanceId, _this27.state.completedDecisions, false, _this27.state.customerId, undefined, undefined, undefined, true, _this27.state.currentCustomer.Language, _this27.state.pickupId, undefined, _this27.state.isResumingOrder);
            }).then(function () {
              if (_this27.state.selectedDeliveryDecision) {
                _this27.handleDeliveryDecision();
              }
              _this27.wizardForm.$setPristine();
            });
          } else {
            this.actions.fetchAttributesAndNavigate({
              offerId: this.state.selectedOfferId,
              offeringInstanceId: this.state.selectedOfferingInstanceId,
              completedDecisions: this.state.completedDecisions,
              customer: this.state.customerInfo,
              completedAttributes: this.state.formattedAttributes,
              completedPhysicalAttributes: [],
              shouldCalculateTaxes: !!this.state.validPaymentInfo,
              paymentInstrument: [this.state.validPaymentInfo],
              isMultiOfferEditing: this.state.isMultiOfferEditing,
              isDbss: this.state.isDbss,
              changeOfferingInstanceId: this.state.changeOfferingInstanceId,
              pickupId: this.state.pickupId,
              useSavedShoppingCart: this.state.isResumingOrder,
              isMultiOffer: this.state.isMultiOffer
            }).then(function () {
              if (_this27.state.selectedDeliveryDecision) {
                _this27.handleDeliveryDecision();
              }
              _this27.wizardForm.$setPristine();
            });
          }
        }
      } else {
        this.$log.warn('The current step has errors');
      }
    }
  }, {
    key: "checkCreditAndFinanceLimitAndSubmitOrder",
    value: function checkCreditAndFinanceLimitAndSubmitOrder(billCycle, shoppingCart, paymentInfo) {
      var isFinanceCreditLimitBreached = this.validateFinanceCreditLimitFromQuote();
      if (!this.state.isCreditLimitBreached && !isFinanceCreditLimitBreached) {
        this.addOfferSubmitOrder(billCycle, shoppingCart, paymentInfo);
      }
    }
  }, {
    key: "validateFinanceCreditLimitFromQuote",
    value: function validateFinanceCreditLimitFromQuote() {
      return this.state.availableFinanceCreditFromQuote > 0;
    }
  }, {
    key: "handleDeliveryDecision",
    value: function handleDeliveryDecision() {
      if (this.state.selectedDeliveryDecision !== this.state.selectedDeliveryDecisionFromRoc) {
        this.actions.setDeliveryDecision(this.state.selectedDeliveryDecisionFromRoc);
        this.actions.setSelectedInventoryStores([]);
      }
    }
  }, {
    key: "addOfferSubmitOrder",
    value: function addOfferSubmitOrder(billCycle, shoppingCart, paymentInfo) {
      var _this28 = this;
      var transferFromSubscriberId = this.state.isTransferWizard ? Object.assign({}, {
        TransferFromSubscriberId: this.state.transferFromSubscriberId
      }) : null;
      var physicalInventoryDetails = this.state.subscriberPhysicalInventoryPickupDetail.id ? Object.assign({}, {
        SubscriberPhysicalInventoryPickupDetail: {
          Id: this.state.subscriberPhysicalInventoryPickupDetail.id,
          Comments: this.state.subscriberPhysicalInventoryPickupDetail.comments,
          PickupDate: this.state.subscriberPhysicalInventoryPickupDetail.date
        }
      }) : null;
      return this.actions.submitAddOrder(this.state.customerInfo, Object.assign({}, shoppingCart, transferFromSubscriberId, physicalInventoryDetails), paymentInfo, billCycle, this.state.executionOptions, this.state.recordPaymentInfo, this.state.isTransferWizard,
      // Uses the same actions because they have the same schema / requirements
      this.state.orderAdditionalProperties, this.state.selectedShippingAddressAndMethod, this.state.orderDetails, this.state.isMultiOffer ? undefined : this.state.offerAdditionalProperties).then(function () {
        if (_this28.state.isResumingStoreOrder) {
          _this28.actions.setIsResumingStoreOrder(false);
        }
        _this28.deregisterUnsavedChanges();
        _this28.$scope.orderConfirmationPopup.open();
      }).catch(function (error) {
        error.Code === convertStringToNumber(FaultCodeKeys.LITE_CUSTOMER_SUBMISSION_ERROR_CODE) ? _this28.openEditProfileInformationPopup() : _this28.submitOrderErrorPopupApi.open(error);
      });
    }
  }, {
    key: "recalculateOrderQuote",
    value: function recalculateOrderQuote(updatedPaymentInfo) {
      var _this29 = this;
      var nextTaxCountry = pathOr(null, ['BillingAddress', 'Country'], updatedPaymentInfo);
      var nextTaxState = pathOr(null, ['BillingAddress', 'State'], updatedPaymentInfo);
      if (!this.currentTaxCountry || this.currentTaxCountry !== nextTaxCountry || !this.currentTaxState || this.currentTaxState !== nextTaxState) {
        this.actions.calculateAddOfferOrderQuoteWithTaxes(this.state.customerInfo, this.state.multiOfferShoppingCart, updatedPaymentInfo ? [updatedPaymentInfo] : [this.state.paymentInfoEdit], this.state.isDbss, this.state.executionOptions, this.state.billCycle, this.state.shippingAddress ? true : false).then(function () {
          if (_this29.state.asyncId) {
            _this29.repeatRetrieveQuote();
          }
          _this29.currentTaxCountry = nextTaxCountry;
          _this29.currentTaxState = nextTaxState;
        }).catch(function (error) {
          _this29.uiNotificationService.transientError(error.translatedMessage);
        });
      }
    }
  }, {
    key: "recallOfferingContext",
    value: function recallOfferingContext() {
      var _this30 = this;
      this.actions.fetchAttributes({
        offeringId: this.state.selectedOfferId,
        offeringInstanceId: this.state.selectedOfferingInstanceId,
        completedDecisions: this.getCompletedDecisions(),
        completedAttributes: this.state.formattedAttributes,
        completedPhysicalAttributes: this.state.formattedPhysicalAttributes,
        isConvergentBiller: true,
        isReconnectAction: false,
        changeOfferingInstanceId: this.state.changeOfferingInstanceId,
        useSavedShoppingCart: this.state.isResumingOrder,
        pickupId: this.state.pickupId
      }).catch(function (error) {
        if (error) {
          _this30.uiNotificationService.transientError(error.translatedMessage);
        }
      });
    }
  }, {
    key: "tabSelected",
    value: function tabSelected(selectedTab) {
      var selectedIndex = findIndex(function (tab) {
        return tab === selectedTab;
      })(this.state.tabs);
      this.actions.setSelectedTab(selectedIndex);
    }
  }, {
    key: "redirectToCustomer",
    value: function redirectToCustomer() {
      this.$scope.orderConfirmationPopup.close();
      this.deregisterUnsavedChanges();
      this.$state.go(CUSTOMER_URL, {
        'customerId': this.state.isTransferWizard ? this.state.transferFromSubscriberId : this.state.customerInfo.Id,
        'showAutoPayBanner': {
          enabled: this.state.showCustomerAutoPayBanner,
          customerId: this.state.customerInfo.Id
        }
      }, {
        reload: true
      });
    }
  }, {
    key: "launchSaveOrder",
    value: function launchSaveOrder() {
      if (this.state.isAttributesStep) {
        this.handleAttributeValidations(false, true);
      } else if (this.state.isCheckoutStep) {
        this.openSaveOrderPopup();
      }
    }
  }, {
    key: "handlePreviewRenewalStatements",
    value: function handlePreviewRenewalStatements() {
      this._openPreviewRenewalStatementsPopup();
    }
  }, {
    key: "handleClosePreviewRenewalStatementsDialog",
    value: function handleClosePreviewRenewalStatementsDialog() {
      this._closePreviewRenewalStatementsPopup();
    }
  }, {
    key: "_openPreviewRenewalStatementsPopup",
    value: function _openPreviewRenewalStatementsPopup() {
      this.showPreviewRenewalStatementsDialog = true;
      this.$timeout(this._previewRenewalStatementsPopupApi.open);
    }
  }, {
    key: "_closePreviewRenewalStatementsPopup",
    value: function _closePreviewRenewalStatementsPopup() {
      this.showPreviewRenewalStatementsDialog = false;
      this._previewRenewalStatementsPopupApi.close();
    }

    // Handler to open the modal dialog that allows the CSR to select a Store.
  }, {
    key: "onSelectInventoryStore",
    value: function onSelectInventoryStore() {
      var _this31 = this;
      if (this.state.isCheckoutStep) {
        this.openStoreSearch(true);
      } else {
        if (this.state.selectedInventoryRegion) {
          this.actions.setInventoryRegionFilter(this.state.selectedInventoryRegion);
        }
        this.showSelectStorePopup = true;
        this.$timeout(function () {
          _this31.selectStorePopupApi.open();
        });
      }
    }

    /**
     * Updates Shopping Cart for Multi-Offer & Refreshes Shopping Cart for Single offer; on Attributes & Checkout Step.
     * Ensures the correct Store ID is configured for all items in the Shopping Cart (both Single & Multi-offer).
     */
  }, {
    key: "_updateShoppingCart",
    value: function _updateShoppingCart() {
      var _this32 = this;
      var isSaveOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var isSendToStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var isConfirmation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var reduxActionsStatuses = {
        isMultiOfferCartUpdated: false,
        isQuoteRefreshed: false,
        // both Single & Multi-Offer
        isSingleOfferValidated: false
      };
      if (!isConfirmation && (this.state.isAttributesStep || this.state.isCheckoutStep)) {
        if (this.state.isMultiOffer || isSaveOrder) {
          var modifiedShoppingCartForAPIRequest;
          var shoppingCartToUpdateStoreIdOn = this.state.isAttributesStep ? this.state.isMultiOfferEditing || isSendToStore || this.state.changeOfferingInstanceId || this.state.isMultiOffer ? this.state.editedMultiOfferShoppingCart : this.state.shoppingCart : this.state.multiOfferShoppingCart;
          modifiedShoppingCartForAPIRequest = this.state.isInventoryStoreChanged && this.state.selectedInventoryStores && this.state.selectedInventoryStores.length ? getShoppingCartWithUpdatedStoreIdForAPIRequest(shoppingCartToUpdateStoreIdOn, this.state.selectedInventoryStores[0].Value) : shoppingCartToUpdateStoreIdOn;
          var isAppendItemsToCart = this.state.isAttributesStep ? this.state.isMultiOffer && !(this.state.isMultiOfferEditing || this.state.changeOfferingInstanceId) : false;
          var cartItemsObj;
          if (this.state.isMultiOffer) {
            cartItemsObj = getMultiOfferShoppingCartWithUpdatedDeliveryDecision(modifiedShoppingCartForAPIRequest, this.state.selectedDeliveryDecision);
            modifiedShoppingCartForAPIRequest = cartItemsObj.cartItems;
          }

          // Invoking update shopping cart also validates the items in the cart.
          var customerId = this.state.customerInfo.Id;
          var updateShoppingCartPromise = this.state.isCheckoutStep ? this.actions.replaceMultiOfferShoppingCart(customerId, modifiedShoppingCartForAPIRequest) : this.actions.updateMultiOfferShoppingCart(customerId, this.state.cartAdditionalProperties.length ? Object.assign({}, modifiedShoppingCartForAPIRequest, {
            AdditionalProperties: this.state.cartAdditionalProperties
          }) : modifiedShoppingCartForAPIRequest, cartItemsObj ? cartItemsObj.isAppend : isAppendItemsToCart);
          return updateShoppingCartPromise.then(function () {
            if (_this32.state.changeOfferingInstanceId) {
              _this32.resetChange();
            }
            if (_this32.state.isInventoryStoreChanged && isAppendItemsToCart && !_this32.state.isMultiOfferEditing) {
              // This happens on Attributes Step when adding a new Offer on the multi-offer flow.
              // And the CSR changes the Store. Need to update Store ID for the previously added offers.
              var modifiedAllItemsInShoppingCartForAPIRequest = getShoppingCartWithUpdatedStoreIdForAPIRequest(_this32.state.multiOfferShoppingCart, _this32.state.selectedInventoryStores[0].Value);
              return _this32.actions.replaceMultiOfferShoppingCart(customerId, modifiedAllItemsInShoppingCartForAPIRequest);
            }
          }).then(function () {
            _this32.actions.clearOfferingOrderQuote();
            reduxActionsStatuses.isMultiOfferCartUpdated = true;
            // You can reset the Inventory Store Change flag, because all Physical Inventory Items in the Shopping Cart now have the same Store ID.
            _this32.actions.setInventoryStoreChangedFlag(false);
            if (!isSaveOrder) {
              return _this32.actions.retrieveShoppingCartOfferings(customerId);
            } else {
              return null;
            }
          }).then(function (retrieveShoppingCartOfferingsResponse) {
            if (retrieveShoppingCartOfferingsResponse !== null && !isSaveOrder) {
              _this32.actions.clearQuote();
              if (isSendToStore) {
                return Promise.resolve(reduxActionsStatuses);
              } else {
                return _this32.actions.calculateOfferingOrderQuote(_this32.state.customerInfo, retrieveShoppingCartOfferingsResponse.ShoppingCart, _this32.state.billCycle, _this32.state.executionOptions, undefined, _this32.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED, _this32.overrideBypassQuoteConfiguration).catch(function (error) {
                  return Promise.reject(error);
                });
              }
            } else {
              return null;
            }
          }).then(function () {
            if (_this32.state.asyncId) {
              _this32.repeatRetrieveQuote();
            }
            reduxActionsStatuses.isQuoteRefreshed = !isSaveOrder;
            return reduxActionsStatuses;
          }).catch(function (error) {
            _this32.uiNotificationService.transientError(error.translatedMessage);
            return Promise.reject(reduxActionsStatuses);
          });
        } else {
          if (!this.state.isCheckoutStep) {
            this.actions.setMultiOfferShoppingCart(this.state.shoppingCart);
          }
          if (isSendToStore) {
            return Promise.resolve(reduxActionsStatuses);
          } else {
            this.actions.clearQuote();
            var shoppingCartWithUpdateStoreId = this.state.isInventoryStoreChanged && this.state.selectedInventoryStores && this.state.selectedInventoryStores.length ? getShoppingCartWithUpdatedStoreIdForAPIRequest(this.state.multiOfferShoppingCart, this.state.selectedInventoryStores[0].Value) : this.state.multiOfferShoppingCart;
            return this.actions.calculateOfferingOrderQuote(this.state.customerInfo, shoppingCartWithUpdateStoreId, this.state.billCycle, this.state.executionOptions, undefined, this.state.selectedDeliveryDecision === DELIVERY_OPTIONS.SHIPPED, this.overrideBypassQuoteConfiguration).then(function () {
              if (_this32.state.asyncId) {
                _this32.repeatRetrieveQuote();
              }
              reduxActionsStatuses.isQuoteRefreshed = true;
              return reduxActionsStatuses;
            }).catch(function (error) {
              return Promise.reject(error);
            });
          }
        }
      } else {
        return Promise.resolve(reduxActionsStatuses);
      }
    }
  }, {
    key: "closeSelectStorePopupDialog",
    value: function closeSelectStorePopupDialog(isApplyChanges, selectedStore) {
      this.showSelectStorePopup = false;
      if (isApplyChanges) {
        this.actions.setSelectedInventoryStores([selectedStore]);
      }
      this.actions.setInventoryRegionFilter(null);
      this.selectStorePopupApi.close();
    }
  }, {
    key: "onInventoryRegionFilterChanged",
    value: function onInventoryRegionFilterChanged(region) {
      this.actions.setInventoryRegionFilter(region);
    }
  }, {
    key: "onInventoryRegionFilterChangedForStoreSearch",
    value: function onInventoryRegionFilterChangedForStoreSearch(region) {
      this.actions.setInventoryRegionFilter(region);
      this.actions.resetAvailableInventoryInformation();
      var formattedInventories = this.state.physicalInventories,
        formattedPayload = !this.state.formattedInventories ? {
          InventoryTypes: formattedInventories,
          RegionId: region
        } : this.state.formattedPhysicalInventories;
      this.actions.searchInventoriesAvailability(formattedPayload).catch(this.onSearchInventoryAvailabilityFailure);
    }
  }, {
    key: "closeSearchInventoryPopupDialog",
    value: function closeSearchInventoryPopupDialog() {
      this.showStoreInventoryPopup = false;
      this.actions.setInventoryRegionFilter(null);
      this.storeSearchInventoryApi.close();
      if (this.isInventoryItemReservationFault) {
        this.openSendToStorePopup();
      }
    }
  }, {
    key: "setSelectedStoreForSearchModal",
    value: function setSelectedStoreForSearchModal(selectedStore) {
      this.actions.setSelectedInventoryStores([selectedStore]);
      this.showStoreInventoryPopup = false;
      this.storeSearchInventoryApi.close();
      if (this.state.isAttributesStep) {
        this.handleAttributeValidations(this.storeSearchSettings.isContinueShopping, this.storeSearchSettings.isSaveOrder, this.storeSearchSettings.isSendToStore, true);
      } else {
        this._updateShoppingCart();
      }
    }
  }, {
    key: "openStoreSearch",
    value: function openStoreSearch() {
      var _this33 = this;
      var isSearchInventoriesAvailability = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.showStoreInventoryPopup = true;
      this.$timeout(function () {
        _this33.storeSearchInventoryApi.open();
        if (isSearchInventoriesAvailability) {
          _this33.actions.searchInventoriesAvailability(_this33.state.formattedPhysicalInventories).then(function () {
            if (_this33.isInventoryItemReservationFault) {
              _this33.isInventoryItemReservationFault = false;
            }
          }).catch(_this33.onSearchInventoryAvailabilityFailure);
        }
      });
    }
  }, {
    key: "getAddressKey",
    value: function getAddressKey() {
      return pathOr(undefined, ['wizardForm', '$ctrl.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'addressKey'], this);
    }
  }, {
    key: "getAddressKeyForAddressValidatedThroughAPI",
    value: function getAddressKeyForAddressValidatedThroughAPI() {
      return pathOr(undefined, ['wizardForm', '$ctrl.paymentInstrumentForm', 'addressWrapupController.singleAddressFormFormApi', 'keyForAddressValidatedThroughAPI'], this);
    }
  }, {
    key: "getJobToken",
    value: function getJobToken() {
      var addressKey = this.getAddressKey(),
        addressKeyForAddressValidatedThroughAPI = this.getAddressKeyForAddressValidatedThroughAPI(),
        validatedAddressForCurrentAddress = this.state.validatedAddresses[addressKey],
        validatedAddressForAddressValidatedThroughAPI = this.state.validatedAddresses[addressKeyForAddressValidatedThroughAPI];
      if (validatedAddressForCurrentAddress && validatedAddressForCurrentAddress.JobToken) {
        return validatedAddressForCurrentAddress.JobToken;
      } else if (validatedAddressForAddressValidatedThroughAPI && validatedAddressForAddressValidatedThroughAPI.JobToken) {
        return validatedAddressForAddressValidatedThroughAPI.JobToken;
      }
      return null;
    }
  }, {
    key: "validateAddressWithAPI",
    value: function validateAddressWithAPI() {
      /*
          This will only get called if the payment instrument component appears which should
          only occure if they have no defaultBilling Payment method
      */
      var addressKey = this.getAddressKey(),
        unvalidatedAddress = this.state.unvalidatedAddresses[addressKey],
        validatedAddress = this.state.validatedAddresses[addressKey],
        addressTypes = {
          DefaultBilling: true
        };
      if (validatedAddress || !unvalidatedAddress) {
        return Promise.resolve(100);
      } else {
        return this.actions.validateAddress(addressKey, unvalidatedAddress, this.getJobToken(), addressTypes);
      }
    }
  }, {
    key: "setCustomerTypeChangeReadOnly",
    value: function setCustomerTypeChangeReadOnly() {
      var alreadyHasCreditCheckClassification = !!this.state.currentCustomer.CreditCheckClassification;
      var hasEditTypeAccess = hasAccess(this.state.userSecurityAttributes, SUBSCRIBER_TYPE_EDIT_ACCESS);
      this.isCustomerTypeChangeReadOnly = alreadyHasCreditCheckClassification && !hasEditTypeAccess && !this.state.isCreatingCustomer;
    }
  }, {
    key: "openEditProfileInformationPopup",
    value: function openEditProfileInformationPopup() {
      var _this34 = this;
      this.showCustomerPopup = true;
      this.$timeout(function () {
        _this34.actions.setEditAdditionalProperty(_this34.state.currentCustomer.AdditionalProperties);
        _this34.editProfileInformationPopupApi.open();
      });
    }
  }, {
    key: "closeEditProfileInformationPopup",
    value: function closeEditProfileInformationPopup() {
      this.showCustomerPopup = false;
      this.editProfileInformationPopupApi.close();
    }
  }, {
    key: "onSubmitEditCustomerForm",
    value: function onSubmitEditCustomerForm() {
      this.showLoadingIndicator = true;
      this.closeEditProfileInformationPopup();
      this.actions.retrieveAvailablePaymentInstrumentTypes();
      this.actions.retrieveWalletAndSelectDefaultPaymentMethod({
        customerId: this.state.customerId
      });
      this.uiNotificationService.transientSuccess(i18n.translate(CustomerCareKeys.PROFILE_PAGE.UPDATE_SUCCESS_MESSAGE));
    }
  }, {
    key: "resetChange",
    value: function resetChange() {
      this.actions.setChangeOfferingId(null);
      this.actions.setChangeOfferingInstanceId(null);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      if (!this.isCartExisting) {
        this.actions.setIsResumingOrder(false);
      }
      this.resetChange();
      this.actions.setTransferFromName('');
      this.disconnectRedux();
    }
  }]);
}(OfferWizard);
export default {
  template: require('./add.offer.wizard.html'),
  controller: AddOfferWizardController,
  controllerAs: 'addOfferController'
};